import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/Header";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Field, Form, Formik } from "formik";
import countryList from 'country-list';
import { getshipping, gettoken, shippinfidstore,shippingidremove } from "../../Localstorage/Store";
import { FaEdit,FaCheck } from "react-icons/fa";
import { getCode } from "country-list";
import { addItem } from "../../store/state/cart";
import { useDispatch, useSelector } from "react-redux";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { IoIosArrowRoundBack } from "react-icons/io";
import Accountprice from "../../utils/Accountprice";
import { checkoutvalidation } from "../../Validation/Checkout";
import { checkoutvalidation2 } from "../../Validation/Checkout2";

const OrderRequest = () => {
  const { bgColor, textColor } = useSelector((state) => state.theam);
  const [currentaddress,setcurrentaddress] = useState({})
    const [countriesdata, setcountriesdata] = useState([]);
  const [showtax, setshowtax] = useState(false);
  const [loading, setloading] = useState(false);
    const closeaddressbtn = useRef(null);
      const [cityna, setcityna] = useState("");
      const buttonRef = useRef(null);
        const editformopen2 = useRef(null);
  const [vouchervalue, setvouchervalue] = useState('');
  const [totalitemvalue, settotalitemvalue] = useState(0);
  const [discountval, setdiscountval] = useState(0);
  const [totalmrp, settotalmrp] = useState(0);
  const [data, setData] = useState([]);
  const [voucherlist, setvoucherlist] = useState([]);
  const [voucherlist2, setvoucherlist2] = useState([]);
  const [cartinfo, setcartinfo] = useState({});
  const tokenvalue = gettoken();
  const nvg = useNavigate();
  const location = useLocation();
  const gobalvariable = useSelector(state => state);
  const dispatch = useDispatch();
  const { orderid } = useParams()
  const [singleorder, setsingleorder] = useState({})
  const [isshoppingvoucher, setisshoppingvoucher] = useState([]);
  const [offeramount_totalwithqty, setofferamount_totalwithqty] = useState(0);
  const [qty_total, setqty_total] = useState(0);
  const [taxable_total, settaxable_total] = useState(0);
  const [gst_total, setgst_total] = useState(0);
  const [offerSum, setOfferSum] = useState(0);
  const [shippingaddressopen, setshippingaddressopen] = useState(false);
    const [addressstatus, setaddressstatus] = useState(false);
  const [paymentstatus, setpaymentstatus] = useState(null);
  const [finalorderamount, setfinalorderamount] = useState(0);
  const [firstname_super, setfirstname_super] = useState("");
  const [lastname_super, setlastname_super] = useState("");
  const [phonenumber_super, setphonenumber_super] = useState("");
  const [emailid_super, setemailid_super] = useState("");
  const [address_type, setaddress_type] = useState("");
  const [address1_super, setaddress1_super] = useState("");
  const [address2_super, setaddress2_super] = useState("");
  const [country2_super, setcountry2_super] = useState("");
  // const [country2url_super, setcountry2url_super] = useState("");
  const [state2_super, setstate2_super] = useState("");
  const [city2_super, setcity2_super] = useState("");
  const [pincode2_super, setpincode2_super] = useState("");
  const [shipping_price, setshipping_price] = useState(0);
  const calculateOfferSum = (data) => {
    const sum = data.reduce((acc, item) => acc + item.offer, 0);
    setOfferSum(sum);
  };

  // console.log("clg shipping price is here",shipping_price);
  const shippingid = getshipping();
  const editformopen = useRef(null);
  const editfromclose = useRef(null);
  const [shipaddress, setshipaddress] = useState(false);
  const [addressdata, setaddressdata] = useState([]);
  const [shiploading, setshiploading] = useState(false);
  const [slectaddressid, setslectaddressid] = useState(0);
  const [shippingerror, setshippingerror] = useState(null);


  console.log("selected address id is here",slectaddressid,"new shiping id",shippingid)
  const billingaddressorder = addressdata.filter((item) => item.id == slectaddressid);
  const shippingaddressorder = addressdata.filter((item) => item.id == shippingid);

  console.log("check shipping address",shippingaddressorder[0],"checking billling address",billingaddressorder[0]);
  const handleEdit = () => {
    const buttonNode = editformopen.current;
    // console.log("this is add utt 0000",)
    // seteditformvalue()
    if (buttonNode) {
      buttonNode.click();
    }
  };

  async function getcountries() {
    let url = `${process.env.REACT_APP_API_URL}api/countries/`;
    try {
      const response = await axios.get(url);

      setcountriesdata(response.data);
    } catch (error) {}
  }


    const fetchstateandcity = async (value, setFieldError, setFieldValue) => {
      if (value.length == 6) {
        try {
          let url = `${process.env.REACT_APP_API_URL}my_api/get-postcode-information/?postal_code=${value}`;
          const response = await axios.get(url);
          // setFieldValue("city", response.data.city);
          if (response.data.city == "NA") {
            setFieldValue("city", "");
            setcityna("NA");
            setFieldError("city", "Please Enter Your City");
          } else {
            setFieldValue("city", response.data.city);
            setcityna("");
          }
          setFieldValue("state", response.data.state);
          const countrydata = countriesdata.filter(
            (item2) => item2.printable_name == response.data.country.trim()
          );
          // console.log(";;;;;;", countrydata);
          setFieldValue("country", countrydata[0].printable_name);
          setFieldValue("countryurl", countrydata[0].url);
        } catch (error) {
          setFieldError("pincode", error.response.data.message);
        }
      } else {
        setFieldValue("city", "");
        setFieldValue("state", "");
        setFieldValue("country", "");
        setFieldValue("countryurl", "");
      }
    };

  const handleEdit5 = () => {
    const buttonNode = editfromclose.current;
    if (buttonNode) {
      buttonNode.click();
    }
  };

  const handleClick = () => {
    const buttonNode = buttonRef.current;
    // console.log("this is add utt",)
    if (buttonNode) {
      buttonNode.click();
    }
  };

  const handleEdit2 = () => {
    const buttonNode = editformopen2.current;
    // console.log("this is add utt 0000",)
    // seteditformvalue()
    if (buttonNode) {
      buttonNode.click();
    }
  };

  const handleEdit3 = () => {
    const buttonNode = closeaddressbtn.current;
    if (buttonNode) {
      buttonNode.click();
    }
  };

    const setshippadd = (id) => {
      shippinfidstore(id);
      const selectadd = addressdata.filter((item) => item.id == id);
      shippingcharges(selectadd[0].postcode);
      handleEdit5();
    };

    const selectaddress = async (address) => {
      if (shipaddress == false) {
        const selectadd = addressdata.filter((item) => item.id == address);
        setslectaddressid(address);
        // console.log("select address is and full data",selectadd,"dkdkdkdkd",addressdata,"dkdkdkdkdkdkdkd",address)
        shippingcharges(selectadd[0].postcode);
      } else {
        setslectaddressid(address);
      }
    };
    const editselectaddress = async () => {
      const selectadd = addressdata.filter((item) => item.id == slectaddressid);
      setfirstname_super(selectadd[0].first_name);
      setlastname_super(selectadd[0].last_name);
      setphonenumber_super(selectadd[0].phone_number);
      setemailid_super(selectadd[0].email);
      setaddress1_super(selectadd[0].line1);
      setaddress_type(selectadd[0].address_type);
      setaddress2_super(selectadd[0].line2);
      setcountry2_super(selectadd[0].country_printable_name);
      // setcountry2url_super(selectadd[0].)
      setstate2_super(selectadd[0].state);
      setcity2_super(selectadd[0].line4);
      setpincode2_super(selectadd[0].postcode);
      setTimeout(() => {
        handleEdit();
      }, 600);
      // console.log("eidt",selectadd,"dkdkdkdkd",addressdata,"dkdkdkdkdkdkdkd")
    };

  async function getaddress(slectaddressid = 0) {

    // console.log("1234567890-09876545",slectaddressid);
    const config = {
      headers: {
        Authorization: `Bearer ${tokenvalue.access}`,
        "Content-Type": "application/json",
      },
    };
    let url = `${process.env.REACT_APP_API_URL}homepageapi/address/list`;
    try {
      const response = await axios.get(url, config);
      setaddressdata(response.data);
      if (response.data) {
        if (slectaddressid == 0) {
          shippingcharges(response.data[0].postcode);
          setslectaddressid(response.data[0].id);
        } else {


        const matchedAddress = response.data.find(address =>
        address.email === slectaddressid.email &&
        address.phone_number === slectaddressid.phone_number &&
        address.postcode === slectaddressid.postcode &&
        address.state === slectaddressid.state &&
        address.line4 === slectaddressid.line4 &&
        address.last_name === slectaddressid.last_name &&
        address.first_name === slectaddressid.first_name &&
        address.line2 === slectaddressid.line2 &&
        address.line1 === slectaddressid.line1
    );

    //  console.log("ddjdjdjckcc,c,c,c,cc,,cc,",matchedAddress ? matchedAddress.id : null);
          setslectaddressid(matchedAddress ? matchedAddress.id : 0);
        }
 
      }
    } catch (error) {
      // setloading(false)
      // console.log(error)
    }
  }

  
  const createaddress = async (values, setFieldError, shipping = "0") => {
    // console.log("check this createaddress api ")
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${tokenvalue.access}`,
        },
      };
      const formdata = new FormData();
      formdata.append("first_name", values.first_name);
      formdata.append("last_name", values.last_name);
      formdata.append("phone_number", `+91${values.mobile}`);
      formdata.append("line1", values.address1);
      formdata.append("line2", values.address2);
      formdata.append("country", getCode(values.country));
      formdata.append("state", values.state);
      formdata.append("email", values.email);
      formdata.append("line4", values.city);
      formdata.append("address_type", values.address_type);
      formdata.append("postcode", values.pincode);
      if (tokenvalue.msg == "Voucher login") {
        formdata.append("user", tokenvalue.user_id);
      } else {
        formdata.append("user", tokenvalue.id);
      }
      // setloading(true)
      // let url = `${process.env.REACT_APP_API_URL}api/useraddresses/`;
      let url = `${process.env.REACT_APP_API_URL}homepageapi/address/create/`;
      const response = await axios.post(url, formdata, config);
      if (response.data?.id) {
        // console.log("reespnse ravi vffdddrredd",response.data)
        if (shipping == "0") {
          getaddress(response.data.id);
          setaddressstatus(true);
          shippingcharges(response.data.postcode);
          // setslectaddressid()
          handleEdit3();
          setTimeout(() => {
            setaddressstatus(false);
            handleClick();
          }, 3000);
        } else {
          getaddress();
          shippingcharges(response.data.postcode);
          shippinfidstore(response.data.id);
          //  shippinfidstore(response.data.id)
          // setshipaddress(false)
          setshippingaddressopen(false);
          handleEdit5();
        }
      } else {
      }
    } catch (error) {
      setFieldError("mobile", error.response.data.phone_number[0]);
    }
  };


    const shippingcharges = async (pin) => {
      try {
        setshiploading(true);
        const config = {
          headers: {
            Authorization: `Bearer ${tokenvalue.access}`,
            "Content-Type": "application/json",
          },
        };
        const formdata = new FormData();
        formdata.append("pin_code", pin);
        let url = `${process.env.REACT_APP_API_URL}ship/get_price/`;
        const response = await axios.post(url, formdata, config);
        // console.log("reosponse of shipping charges",response)
        // console.log("1 ship charge check here one",response);
        setshipping_price(response.data.total_rate);
        setshippingerror(null);
        setshiploading(false);
      } catch (error) {
        // console.log("error resp of charge api", error.response.data);
        setshippingerror(
          "Oops! We're unable to calculate shipping costs for your order at the moment."
        );
        setshipping_price(0);
        setshiploading(false);
      }
    };

    const editddress = async (values, setFieldError) => {
      try {
        // console.log("this iss ssssss",values)
        const formdata = new FormData();
        formdata.append("first_name", values.first_name2);
        formdata.append("address_type", values.address_type);
        formdata.append("last_name", values.last_name2);
        formdata.append("phone_number", `+91${values.mobile2}`);
        formdata.append("line1", values.address12);
        formdata.append("line2", values.address22);
        formdata.append("country", getCode(values.country2));
        formdata.append("state", values.state2);
        formdata.append("email", values.email2);
        formdata.append("line4", values.city2);
        formdata.append("postcode", values.pincode2);
        if (tokenvalue.msg == "Voucher login") {
          formdata.append("user", tokenvalue.user_id);
        } else {
          formdata.append("user", tokenvalue.id);
        }
        const config = {
          headers: {
            Authorization: `Bearer ${tokenvalue.access}`,
          },
        };
  
        let url = `${process.env.REACT_APP_API_URL}homepageapi/address/${slectaddressid}/update/`;
        const response = await axios.put(url, formdata, config);
        // console.log("show me response of response id",response);
        if (response.data?.id) {
          //  console.log("reespnse ravi",response.data)
          //  getaddress("new")
          getaddress(slectaddressid);
          shippingcharges(values.pincode2);
          setslectaddressid(response.data.id);
  
          handleEdit5();
  
          //  sethideorshowform(true)
          //  setnewaddress('add',response.data)
        } else {
        }
      } catch (error) {
        //  console.log("firstnnnnnnnnn,,,",error.response)
        setFieldError("mobile2", error.response.data.phone_number[0]);
      }
    };

    const togglefun = () => {
      if (shipaddress == true) {
        shippingcharges(pincode2_super);
        setshipaddress(!shipaddress);
  
        handleEdit5();
      } else {
        if (shippingid) {
          shippingidremove();
          setTimeout(() => {
            setshipaddress(!shipaddress);
          }, 300);
        } else {
          setshipaddress(!shipaddress);
        }
      }
    };

    const fetchstateandcity2 = async (value, setFieldError, setFieldValue) => {
      if (value.length == 6) {
        try {
          let url = `${process.env.REACT_APP_API_URL}my_api/get-postcode-information/?postal_code=${value}`;
          const response = await axios.get(url);
          // setFieldValue("city", response.data.city);
          if (response.data.city == "NA") {
            setFieldValue("city2", "");
            setcityna("NA");
            setFieldError("city2", "Please Enter Your City");
          } else {
            setFieldValue("city2", response.data.city);
            setcityna("");
          }
          setFieldValue("state2", response.data.state);
          const countrydata = countriesdata.filter(
            (item2) => item2.printable_name == response.data.country.trim()
          );
          // console.log(";;;;;;", countrydata);
          setFieldValue("country2", countrydata[0].printable_name);
          setFieldValue("countryurl2", countrydata[0].url);
        } catch (error) {
          setFieldError("pincode2", error.response.data.message);
        }
      } else {
        setFieldValue("city2", "");
        setFieldValue("state2", "");
        setFieldValue("country2", "");
        setFieldValue("countryurl2", "");
      }
    };  



    const seteditformvalue = (setFieldValue) => {
      setFieldValue("first_name2", firstname_super);
      setFieldValue("last_name2", lastname_super);
      setFieldValue("mobile2", phonenumber_super.substring(3));
      setFieldValue("address12", address1_super);
      setFieldValue("address_type", address_type);
      setFieldValue("address22", address2_super);
      setFieldValue("city2", city2_super);
      setFieldValue("email2", emailid_super);
      setFieldValue("state2", state2_super);
      setFieldValue("pincode2", pincode2_super);
      const countrydata = countriesdata.filter(
        (item2) => item2.printable_name == country2_super
      );
      setFieldValue("country2", countrydata[0].printable_name);
      setFieldValue("countryurl2", countrydata[0].url);
      setTimeout(() => {
        handleEdit2();
      }, 600);
    };


  useEffect(() => {
    async function orderdetail() {
      const config = {
        headers: {
          Authorization: `Bearer ${tokenvalue.access}`,
          'Content-Type': 'application/json',
        },
      };
      // let url = `${process.env.REACT_APP_API_URL}homepageapi/GetVouchersView`;
      let url = `${process.env.REACT_APP_API_URL}my_api/get-single_order/${orderid}`;
      try {
        setloading(false)
        const response = await axios.get(url, config);
        setsingleorder(response.data);
        setpaymentstatus(response.data.payment_mode)
        
        getaddress(response.data.shipping_address)
        // getaddress(response.data.shipping_address.id)
        setfinalorderamount(response.data.balance_payable)
        let shoppingvoucher = response.data.voucher_list.filter((item) => item.voucher_type == "Shopping Voucher - Exclusive" || item.voucher_type == "Gift Voucher - Exclusive");
        setisshoppingvoucher(shoppingvoucher);
        // console.log("order s", response.data)
        if (response.data.product_deatils) {
          const updatedProducts = response.data.product_deatils.map(product => ({
            ...product,
            calculatedPercentOfMRP: product.discount_type == "percentage" ? (product.discount / 100) * product.mrp * product.quantity : product.discount * product.quantity,
          }));
          const totalPrice = updatedProducts.reduce((acc, product) => acc + product.calculatedPercentOfMRP, 0);
          const totalmrp = updatedProducts.reduce((acc, product) => acc + (product.mrp * product.quantity), 0);
          const totalitem = updatedProducts.reduce((acc, product) => acc + (1 * product.quantity), 0);
          const offerpricewithqty = updatedProducts.reduce((total, item) => total + (item.price_excl_tax * item.quantity), 0);
          const gsttotal = updatedProducts.reduce((total, item) => total + (item.gst_tax_amount * item.quantity), 0);
          const taxabletotal = updatedProducts.reduce((total, item) => total + (item.base_price * item.quantity), 0);
          const qtytotal = updatedProducts.reduce((total, item) => total + item.quantity, 0);
          // const setofferamount_totalwithqty = updatedProducts.reduce((total, item) => total + item.price_incl_tax, 0);
          setgst_total(gsttotal)
          setvoucherlist2(response.data.voucher_list)
          calculateOfferSum(response.data.voucher_list)
          settaxable_total(taxabletotal)
          setqty_total(qtytotal)
          setofferamount_totalwithqty(offerpricewithqty)
          settotalitemvalue(totalitem)
          setdiscountval(totalPrice)
          settotalmrp(totalmrp)
          setData(updatedProducts);
          setcartinfo(response.data.product_deatils);
          setloading(true)
        }

      } catch (error) {
        setloading(true)
      }
    }
    getcountries()
    orderdetail()
  }, [])








  



  const [showtrack, setshowtrack] = useState(false);
  const [awbNumber, setawbNumber] = useState(null);
  const [trackingData, setTrackingData] = useState({});






  async function payment() {
    
      var options = {
        key: process.env.REACT_APP_PAYMENT_KEY,
        key_secret: process.env.REACT_APP_PAYMENT_KEY_SECRET,
        amount: Number(parseFloat(finalorderamount) * 100).toFixed(0) > 0 ? Number(parseFloat(finalorderamount) * 100).toFixed(0) : 0,
        // amount: (Number(parseFloat(location.state.total) + parseFloat(shippingcharnge?.shipping_price)) * 100).toFixed(2),
        currency: "INR",
        order_receipt: "order_oneupshop",
        name: "OneUpShop",
        description: "for testing purpose",
        handler: async function (response) {
          const paymentId = response.razorpay_payment_id;    
          try {
            orderrequest()
          } catch (error) {
            // nvg("/")
          }
        },
    
        theme: {
          color: `#${bgColor}`,
        },
        modal: {
          ondismiss: function () {
              // setTimeout(() => {
              //   unfreezestatus(freezeid,keyvalue,ids)
              // }, 2000);
          }
      },
      };
      var pay = new window.Razorpay(options);
      pay.open();
    
    
    
    
    
    }





    const orderrequest = async() => {
    
        try {
          const formdata = new FormData();
          formdata.append("orderid", orderid);
          if(shippingaddressorder[0]  == undefined){
          formdata.append("shippingaddress", JSON.stringify(billingaddressorder[0]));
        }else{
            formdata.append("shippingaddress", JSON.stringify(shippingaddressorder[0]));
          }

         if(shipping_price == 0){
          formdata.append("shipping_price", singleorder?.shiping_charge);
         }else{
          formdata.append("shipping_price", shipping_price);
         } 
          formdata.append("billingaddress", JSON.stringify(billingaddressorder[0]));

          const config = {
            headers: {
              Authorization: `Bearer ${tokenvalue.access}`,
            },
          };

          let url = `${process.env.REACT_APP_API_URL}my_api/payment-done/`;
          const response = await axios.post(url, formdata,config);
          console.log("check the response of order request",response);
          if(response.data.message == "Order successfully!"){
            nvg('/order-history')
          }

        } catch (error) {
          console.log("error is here",error);
        }
       
    };

  const fetchTrackingData = async (item) => {
    setawbNumber(item);
console.log("skskskkskks",item)
    try {
      const url = `${process.env.REACT_APP_API_URL}ship/track-order-now?awb=${item}`;
      const response = await axios.get(url);

      if (response.data) {
        // Assuming response.data is a JSON string
        const jsonData = JSON.parse(response.data);
        console.log("gddffddgdg dfdd",jsonData)
        setTrackingData(jsonData);
        setshowtrack(true);
      } else {
        setshowtrack(false);
      }
    } catch (error) {
      console.error('Error fetching tracking data:', error);
      setshowtrack(false);
    }
  };



  return (
    loading == false ? <></> : <>
      <Header />


      <div className="breadcrumb-main marginfromtop" style={{ background: "#fff" }}>
        <div className="container m-0">
          <div className="row">
            <div className="col">
              <div className="breadcrumb-contain">
                <div>
                  <ul>
                    <li><a href="/home">home</a></li>
                    <li>{`>`}</li>
                    <li><a href="javascript:void(0)">Order Detail</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*section start*/}
      <section className="section-big-py-space b-g-light ">
        <div className="container-fluid d-flex justify-content-center">
          <div className="row justify-content-center definewidth" >
            <div className="col-md-8">

              <div className="table-responsive hist" style={{ borderRadius: "6px" }}>
                <h5 style={{ padding: '9px 9px', fontWeight: 400, fontSize: 14, paddingBottom: '20px', cursor: 'pointer' }} onClick={() => { nvg("/order-history") }}><IoIosArrowRoundBack size={24}  style={{ color: `#${textColor}`}}
                />
                Back to list</h5>
                <div className=""><h4 className="Orderstatus addmedia" style={{ width: '100%', display: 'flex', justifyContent: 'space-between', padding: '0px 9px', fontWeight: 700, fontSize: "13px", paddingBottom: '20px', paddingTop: '10px' }}>Order Id: {orderid}    <span> {new Date(singleorder.order_date.split('Time')[0]).toLocaleDateString('en-GB', { hour: 'numeric', minute: 'numeric' })}</span>   <span style={{ display: 'block', color: 'black', textTransform: 'capitalize' }}>Order Status: <img src={`${process.env.REACT_APP_API_PUBLIC_URL}/images/icon/success.png`} alt="404" /> {singleorder.order_status == "Quotation_Shared" ? "Quotation Shared" : singleorder.order_status}</span></h4></div>

              



<table className="table">
                      <thead>
                        <tr>
                          <th
                            className="family"
                            style={{
                              fontWeight: 600,
                              fontSize: "13px",
                              width: "15%",
                              textAlign: "center",
                            }}
                          >
                            Image
                          </th>
                          <th
                            className="family"
                            style={{
                              fontWeight: 600,
                              fontSize: "13px",
                              width: "12%",
                              textAlign: "center",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Product Name
                          </th>
                        
                          <th
                            className="family"
                            style={{
                              fontWeight: 600,
                              fontSize: "13px",
                              width: "16%",
                              textWrap:'nowrap',
                              textAlign: "center",
                            }}
                          >
                            {/* Unit Price */}
                            Offer Price
                          </th>
                          {voucherlist2[0]?.voucher_type == "Gift Voucher - Inclusive" || voucherlist2[0]?.voucher_type == "Gift Voucher - Exclusive" ? <th
                            className="family"
                            style={{
                              fontWeight: 600,
                              fontSize: "13px",
                              width: "16%",
                              textWrap:'nowrap',
                              textAlign: "center",
                            }}
                          >
                            {/* Unit Price */}
                            Discount
                          </th> : ''}
                          
                          <th
                            className="family"
                            style={{
                              fontWeight: 600,
                              fontSize: "13px",
                              width: "15%",
                              textAlign: "center",
                            }}
                          >
                            Quantity
                          </th>
                          <th
                            className="family"
                            style={{
                              fontWeight: 600,
                              fontSize: "13px",
                              width: "15%",
                              textWrap:"nowrap",
                              textAlign: "center",
                            }}
                          >
                            Discount
                          </th>
                          <th
                            className="family"
                            style={{
                              fontWeight: 600,
                              fontSize: "13px",
                              width: "18%",
                              textWrap:'nowrap',
                              textAlign: "center",
                            }}
                          >
                            {/* Basic Amount */}
                            Total Amount
                          </th>
                         
                          <th
                            className="family"
                            style={{
                              fontWeight: 600,
                              fontSize: "13px",
                              width: "18%",
                              textWrap:'nowrap',
                              textAlign: "center",
                            }}
                          >
                            {/* Tax Type */}
                            Taxable Value
                          </th>
                          <th
                            className="family"
                            style={{
                              fontWeight: 600,
                              fontSize: "13px",
                              width: "18%",
                              textWrap:'nowrap',
                              textAlign: "center",
                            }}
                          >
                           GST Rate
                          </th>
                          <th
                            className="family"
                            style={{
                              fontWeight: 600,
                              fontSize: "13px",
                              width: "18%",
                              textWrap:'nowrap',
                              textAlign: "center",
                            }}
                          >
                            GST Amount
                          </th>
                          
                          
                        </tr>
                      </thead>
                      <tbody>
                        {data[0]?.product__title ? (
                          data.map((item, index) => (<>
                            <tr>
                              <td
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <div
                                  onClick={() => {
                                    nvg("/bulkproductdetails", {
                                      state: {
                                        id: item.product,
                                        pname: item.product__title,
                                      },
                                    });
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  <img
                                    src={`${process.env.REACT_APP_API_URL}media/${item.image[0].original}`}
                                    width="80px"
                                    height="80px"
                                    alt="cart"
                                    className=" "
                                  />
                                </div>
                              </td>
                              <td
                                className="pnwidth"
                                style={{ position: "relative", top: "0px" }}
                              >
                                <div
                                  style={{
                                    position: "absolute",
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "start",
                                    top: "0px",
                                  }}
                                >
                                  <h6>
                                    <p
                                      style={{
                                        color: "black",
                                        fontSize: "13px",
                                        // lineHeight: "22px",
                                        lineHeight:
                                          item.stock == 0 ? "40px" : "63px",
                                        textAlign: "center",
                                        display: "-webkit-box",
                                        WebkitLineClamp: "1",
                                        WebkitBoxOrient: "vertical",
                                        cursor: "pointer",
                                        overflow: "hidden",
                                        position: "relative",
                                        top: "8px",
                                      }}
                                      onClick={() => {
                                        nvg("/bulkproductdetails", {
                                          state: {
                                            id: item.product,
                                            pname: item.product__title,
                                          },
                                        });
                                      }}
                                    >
                                      {item.product__title}
                                    </p>
                                   
                                    <p
                                      style={{
                                        color: "red",
                                        fontSize: "14px",
                                        textAlign: "center",
                                        position: "relative",
                                        top: "0px",
                                      }}
                                    >
                                      {" "}
                        { (singleorder.order_status !== "Delivery" && singleorder.order_status !== "Cancelled") && item.awb && (
                          <div style={{ color: 'black', fontSize: "14px", lineHeight: item.product__title.length > 23 ? "24px" : "33px", textAlign: 'start', position: 'relative', top: '-19px',left:'8px' }}>
                            <span onClick={() => fetchTrackingData(item.awb)}>
                              Track Awb : <span style={{position:'relative',top:'-5px', color: 'blue', cursor: 'pointer' }}>{item.awb}</span>
                            </span>
                          </div>
                        )}



                                    </p>
                                  </h6>
                                </div>
                              </td>
                              
                              <td
                                style={{ position: "relative", padding: "0px" }}
                              >
                                <h6
                                  className="td-color"
                                  style={{
                                    fontWeight: 400,
                                    lineHeight: "63px",
                                    fontSize: "13px",
                                    textAlign: "center",
                                    textAlign: "center",
                                    position: "relative",
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "start",
                                    top: "8px",
                                  }}
                                >
                                  {/* ₹{item.base_price} old */}
                                  {/* ₹ */}
                                  {Accountprice(item.price_excl_tax)}
                                </h6>
                              </td>
                             {voucherlist2[0]?.voucher_type == "Gift Voucher - Inclusive" || voucherlist2[0]?.voucher_type == "Gift Voucher - Exclusive" ? <td
                                style={{ position: "relative", padding: "0px" }}
                              >
                                <h6
                                  className="td-color"
                                  style={{
                                    fontWeight: 400,
                                    lineHeight: "63px",
                                    fontSize: "13px",
                                    textAlign: "center",
                                    textAlign: "center",
                                    position: "relative",
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "start",
                                    top: "8px",
                                  }}
                                >
                                  ₹{Number.isInteger((item.amount_allocation_by_line)) ? (
                                        item.amount_allocation_by_line) : (item.amount_allocation_by_line).toFixed(2)}
                                </h6>
                              </td> : ''} 
                              <td className="td-color px-3" style={{ fontWeight: 400, lineHeight: "33px", fontSize: "14px", padding: '16px 0px' }}> <span><div style={{ display: 'flex', justifyContent: 'center',position:'relative',top:'6px' }}>{item?.quantity}</div></span> </td>
                              <td
                                style={{ position: "relative", padding: "0px" }}
                              >
                                <h6
                                  className="td-color px-lg-0 px-md-2"
                                  style={{
                                    fontWeight: 400,
                                    lineHeight: "63px",
                                    fontSize: "13px",
                                    // color: "#0cb744",
                                    textAlign: "center",
                                    textAlign: "center",
                                    position: "relative",
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "start",
                                    top: "8px",
                                  }}
                                >
                                  
                                  {item?.quote_discount ? item?.quote_discount : 0}%

                                  
                                </h6>
                              </td>
                              <td
                                style={{ position: "relative", padding: "0px" }}
                              >
                                <h6
                                  className="td-color px-lg-0 px-md-2"
                                  style={{
                                    fontWeight: 400,
                                    lineHeight: "63px",
                                    fontSize: "13px",
                                    // color: "#0cb744",
                                    textAlign: "center",
                                    textAlign: "center",
                                    position: "relative",
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "start",
                                    top: "8px",
                                  }}
                                >
                                  {/* ₹ */}
                                  {Accountprice((
                                   parseInt(item.price_excl_tax) * parseInt(item.quantity)
                                  ).toFixed(0))}{" "}

                                  
                                </h6>
                              </td>
                              
                              <td
                                style={{ position: "relative", padding: "0px" }}
                              >
                                <h6
                                  className="td-color px-lg-0 px-md-2"
                                  style={{
                                    fontWeight: 400,
                                    lineHeight: "63px",
                                    fontSize: "13px",
                                    // color: "#0cb744",
                                    textAlign: "center",
                                    textAlign: "center",
                                    position: "relative",
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "start",
                                    top: "8px",
                                  }}
                                >
                                  {/* IGST */}
                                  {/* ₹ */}
                                  {/* {(parseFloat(item.base_price) * parseInt(item.quantity)).toFixed(0)} */}



                                  {Accountprice(Number.isInteger((item.base_price *
                                        item.quantity
                                      )) ? (
                                        item.base_price *
                                        item.quantity
                                      ) : (
                                        item.base_price *
                                        item.quantity
                                      ).toFixed(2))}
                                </h6>
                              </td>
                              <td
                                style={{ position: "relative", padding: "0px" }}
                              >
                                <h6
                                  className="td-color px-lg-0 px-md-2"
                                  style={{
                                    fontWeight: 400,
                                    lineHeight: "63px",
                                    fontSize: "13px",
                                    // color: "#0cb744",
                                    textAlign: "center",
                                    textAlign: "center",
                                    position: "relative",
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "start",
                                    top: "8px",
                                  }}
                                >
                                  
                                  {item.gst_rate}%
                                  {/* <span style={{ color: "#52bb56" }}>
                                    &nbsp;&nbsp;
                                    {item.voucher?.[0] ? "Applied" : ""}
                                  </span> */}
                                </h6>
                              </td>
                              <td
                                style={{ position: "relative", padding: "0px" }}
                              >
                                <h6
                                  className="td-color px-lg-0 px-md-2"
                                  style={{
                                    fontWeight: 400,
                                    lineHeight: "63px",
                                    fontSize: "13px",
                                    // color: "#0cb744",
                                    textAlign: "center",
                                    textAlign: "center",
                                    position: "relative",
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "start",
                                    top: "8px",
                                  }}
                                >
                                  {/* ₹{item.gst_tax_amount * item.quantity} */}
                                  {/* ₹ */}
                                  {Accountprice(Number.isInteger(item.gst_tax_amount * item.quantity) ? (item.gst_tax_amount * item.quantity) : (item.gst_tax_amount * item.quantity).toFixed(2))}

                                  {/* <span style={{ color: "#52bb56" }}>
                                    &nbsp;&nbsp;
                                    {item.voucher?.[0] ? "Applied" : ""}
                                  </span> */}
                                </h6>
                              </td>
                              {/* <td
                                style={{ position: "relative", padding: "0px" }}
                              >
                                <h6
                                  className="td-color px-lg-0 px-md-2"
                                  style={{
                                    fontWeight: 400,
                                    lineHeight: "63px",
                                    fontSize: "14px",
                                    textAlign: "center",
                                    textAlign: "center",
                                    position: "relative",
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "start",
                                    top: "8px",
                                  }}
                                >
                                  ₹{parseInt((item.price_incl_tax * item.quantity).toFixed(0))}
                                </h6>
                              </td> */}
                            
                            </tr>
                            <tr style={{display:(data.length - 1) == index ? "" : "none" }}>
                              <td colSpan={voucherlist2[0]?.voucher_type == "Gift Voucher - Inclusive" || voucherlist2[0]?.voucher_type == "Gift Voucher - Exclusive" ? 4 : 3} style={{textAlign:'center',fontSize:'12px',fontWeight:'600'}}>TOTAL</td>
                              <td style={{textAlign:'center',fontSize:'12px',fontWeight:'600'}} >{qty_total}</td>
                              <td style={{textAlign:'center',fontSize:'12px',fontWeight:'600'}} ></td>
                              <td style={{textAlign:'center',fontSize:'12px',fontWeight:'600'}} >
                                {/* ₹ */}
                                {Accountprice(offeramount_totalwithqty)}</td>
                              <td style={{textAlign:'center',fontSize:'12px',fontWeight:'600'}} >
                                {/* ₹ */}
                                {Accountprice(taxable_total.toFixed(0))}</td>
                              <td style={{textAlign:'center',fontSize:'12px',fontWeight:'600'}} ></td>
                              <td style={{textAlign:'center',fontSize:'12px',fontWeight:'600'}} >
                                {/* ₹ */}
                                {Accountprice(gst_total.toFixed(0))}</td>
                              {/* <td style={{textAlign:'center',fontSize:'12px',fontWeight:'600'}} ></td> */}
                                </tr>
                                </>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="9">
                              <h6
                                className="td-color"
                                style={{
                                  fontWeight: 400,
                                  lineHeight: "34px",
                                  fontSize: "14px",
                                  color: "#0cb744",
                                  textAlign: "center",
                                }}
                              >
                                No Item Found
                              </h6>
                              <div
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>


                <br />
                {/* <h5 style={{ padding: '9px 9px', fontWeight: 400, fontSize: 14, paddingBottom: '20px' }}><img src="/images/Arrow 1.png" alt /> Back to Shop</h5> */}
              </div>










{/* {console.log("yyyy",voucherlist2)} */}
              {voucherlist2[0]?.offer ? <div style={{ backgroundColor: "white", padding: "0px 6px",marginBottom:"8px" }}>
                    <table className="table bg-white mt-3">
                    <tbody>
                        
                            <tr className="" style={{ borderColor: "#333" }}>
                              <td
                                style={{ fontWeight: "700", fontSize: "18px",display:'flex',gap:'19px',alignItems:'center',flexWrap:'wrap' }}
                              >
                                <span>
                               {/* {voucherlist2.length}  */}
                               Redeem  {voucherlist2[0]?.code ? voucherlist2[0]?.offer_type != "Coupon" ? `Voucher(s)` : `Coupon` : ''}
                                </span>
                                <div style={{ display: "flex", gap: 4 }}>
                        
                      </div>
                      {/* <span style={{ color: "red",fontSize:'12px',fontWeight:'500' }}>{vouchererror}</span> */}
                      {voucherlist2[0]?.code ? voucherlist2[0]?.offer_type != "Coupon" ? <span className="carttotalhere" style={{ color: "",fontSize:'12px',fontWeight:'500' }}>Voucher(s) Applied: <span style={{border: "1px solid #ced4da",padding: "2px 5px"}}>{voucherlist2.length}</span> : Value: <span style={{border: "1px solid #ced4da",padding: "2px 5px"}}>₹{offerSum}</span></span> : "" : ""}
                      {/* <span className="carttotalhere" style={{ color: "",fontSize:'12px',fontWeight:'500' }}>Voucher Total: ₹{offerSum}</span> */}
                              </td>
                              </tr>
                              </tbody>
                    </table>

                    <div className="newscrollerbar" style={{width:'100%'}}>
                    {voucherlist2[0]?.code ? voucherlist2[0]?.offer_type != "Coupon" ? <table className="table-responsive bg-white mt-3" style={{width:'100%'}}>
                    
                    <tbody>
                      {data[0]?.product__title ? (
                        <>
                
                            <tr>
                              <th style={{textAlign:'center',fontSize:'12px'}}>S.NO</th>
                              <th style={{textWrap:'nowrap',fontSize:'12px',width:'18%'}}>Voucher Code</th>
                              <th style={{textWrap:'nowrap',fontSize:'12px',width:'19%'}} className="px-lg-0 px-2">Voucher Type</th>
                              {/* <th style={{textWrap:'nowrap',fontSize:'12px'}} className="px-lg-0 px-2">Basic Amount</th> */}
                              <th style={{textWrap:'nowrap',fontSize:'12px',width:'18%'}} className="px-lg-0 px-2">GST</th>
                              <th style={{textWrap:'nowrap',fontSize:'12px',width:'18%'}} className="px-lg-0 px-2">Shipping</th>
                              <th style={{textWrap:'nowrap',fontSize:'12px'}} className="px-lg-0 px-2">Value</th>
                              <th></th>
                            </tr>
                             {voucherlist2[0]?.code
                            ? voucherlist2.map((item, index) => (
                                <tr >
                                  <td><span style={{display:'flex',width:'100%',justifyContent:'center'}}>{index + 1}</span></td>
                                  <td>
                                    <div>
                                      <div
                                        className="firstrow  py-1 justify-content-between  align-items-center"
                                        style={{
                                          display:"flex",
                                        }}
                                      >
                                        <div
                                          className="firstcontianer d-flex align-items-start"
                                          style={{ gap: 4 }}
                                        >
                                          <div className="containerimg">
                                            <img
                                              src="/images/carticon.png"
                                              style={{width:'15px'}}
                                              alt={404}
                                            />
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              gap: "4px",
                                              alignItems: "baseline",
                                              minWidth: "192px",
                                            }}
                                          >
                                            <p
                                              className="m-0"
                                              style={{
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              }}
                                            >
                                              {item.code} 
                                              {/* applied &nbsp;{" "} */}
                                              {/* {item.voucher_type == "Shopping Voucher - Exclusive" || item.voucher_type == "Gift Voucher - Exclusive" ? "excl. GST"
                                                : "incl. GST"} */}
  








                                             
                                              
                                            </p>
                                          </div>
                                        </div>
                                        {/* <div
                                          className="remove"
                                          style={{
                                            flexDirection: "column",
                                            paddingRight: "0px",
                                            padding: "0px",
                                          }}
                                        >
                                          <span
                                            style={{
                                              color: "#0cb744",
                                              fontWeight: 500,
                                              fontSize: "12px",
                                              position: "relative",
                                              top: "-2px",
                                            }}
                                          >
                                            ₹{item.offer}
                                          </span>
                                      
                                        </div> */}
                                      </div>{" "}
                                    </div>
                                  </td>
                                  {/* <td style={{fontSize:'12px'}}>
                                    Clubbable                                    </td>
                                  <td style={{fontSize:'12px'}}>Payable</td>
                                  <td style={{fontSize:'12px'}}>Payable</td> */}
                                  <td style={{fontSize:'12px'}}>
                                    {item.clubable ? "Clubbable" : "Nonclubbable"} 
                                  </td>
                             
                                  <td style={{fontSize:'12px'}}>{item.voucher_type == "Gift Voucher - Exclusive" || item.voucher_type == "Shopping Voucher - Exclusive" ? "Payable" : "Included"}</td>
                                  <td style={{fontSize:'12px'}}>  {item.shipping_incl == false ? "Payable" : "Included"}       </td>
                                  <td style={{fontSize:'12px'}}>
                                     {/* ₹ */}
                                    {Accountprice(item.offer)}</td>
                                
                                </tr>
                              ))
                            : ""}

                        </>
                      ) : (
                        ""
                      )}
                    </tbody>
                  </table> : <table className="table-responsive bg-white mt-3" style={{width:'100%'}}>
                    
                    <tbody>
                      {data[0]?.product__title ? (
                        <>
                
                            <tr>
                              <th style={{textAlign:'center',fontSize:'12px',width:'8%'}}>S.NO</th>
                              <th style={{textWrap:'nowrap',fontSize:'12px',width:'18%'}}>Coupon Code</th>
                              <th style={{textWrap:'nowrap',fontSize:'12px'}} className="px-lg-0 px-2">Description                              </th>
                              {/* <th style={{textWrap:'nowrap',fontSize:'12px'}} className="px-lg-0 px-2">Basic Amount</th> */}
                              {/* <th style={{textWrap:'nowrap',fontSize:'12px'}} className="px-lg-0 px-2">GST</th>
                              <th style={{textWrap:'nowrap',fontSize:'12px'}} className="px-lg-0 px-2">Shipping</th> */}
                              <th style={{textWrap:'nowrap',fontSize:'12px',width:'8%'}} className="px-lg-0 px-2">Value</th>
                              <th></th>
                            </tr>
                             {voucherlist2[0]?.code
                            ? voucherlist2.map((item, index) => (
                                <tr >
                                  <td><span style={{display:'flex',width:'100%',justifyContent:'center'}}>{index + 1}</span></td>
                                  <td>
                                    <div>
                                      <div
                                        className="firstrow  py-1 justify-content-between  align-items-center"
                                        style={{
                                          display:"flex",
                                        }}
                                      >
                                        <div
                                          className="firstcontianer d-flex align-items-start"
                                          style={{ gap: 4 }}
                                        >
                                          <div className="containerimg">
                                            <img
                                              src="/images/carticon.png"
                                              style={{width:'15px'}}
                                              alt={404}
                                            />
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              gap: "4px",
                                              alignItems: "baseline",
                                              minWidth: "192px",
                                            }}
                                          >
                                            <p
                                              className="m-0"
                                              style={{
                                                fontWeight: 400,
                                                fontSize: "12px",
                                                position:'relative',
                                                top:'3px'
                                              }}
                                            >
                                              {item.code} 
                                              {/* applied &nbsp;{" "} */}
                                              {/* {item.voucher_type == "Shopping Voucher - Exclusive" || item.voucher_type == "Gift Voucher - Exclusive" ? "excl. GST"
                                                : "incl. GST"} */}
  








                                             
                                              
                                            </p>
                                          </div>
                                        </div>
                                        {/* <div
                                          className="remove"
                                          style={{
                                            flexDirection: "column",
                                            paddingRight: "0px",
                                            padding: "0px",
                                          }}
                                        >
                                          <span
                                            style={{
                                              color: "#0cb744",
                                              fontWeight: 500,
                                              fontSize: "12px",
                                              position: "relative",
                                              top: "-2px",
                                            }}
                                          >
                                            ₹{item.offer}
                                          </span>
                                      
                                        </div> */}
                                      </div>{" "}
                                    </div>
                                  </td>
                                  {/* <td style={{fontSize:'12px'}}>
                                    Clubbable                                    </td>
                                  <td style={{fontSize:'12px'}}>Payable</td>
                                  <td style={{fontSize:'12px'}}>Payable</td> */}
                                  <td style={{fontSize:'12px'}}>
                                    {item.description.replace(/[\[\],\']/g,"")     } 
                                    {/* {item.clubable ? "Clubbable" : "Nonclubbable"}  */}
                                  </td>
                             
                                  {/* <td style={{fontSize:'12px'}}>{item.voucher_type == "Gift Voucher - Exclusive" || item.voucher_type == "Shopping Voucher - Exclusive" ? "Payable" : "Included"}</td>
                                  <td style={{fontSize:'12px'}}>  {item.shipping_charge == false ? "Payable" : "Included"}       </td> */}
                                  <td style={{fontSize:'12px'}}> 
                                    {/* ₹ */}
                                    {Accountprice(item.offer)}
                                    </td>
                                
                                </tr>
                              ))
                            : ""}

                        </>
                      ) : (
                        ""
                      )}
                    </tbody>
                  </table> : ''}
                    </div>
                  </div> : ''}







            </div>



                
            <div className=" col-lg-4 col-md-4 mt-lg-0 mt-md-0 mt-sm-3 ">
               
            {/* <div
                className="py-2 mt-lg-0 mt-md-3 mt-3 mb-2"
                style={{ background: "#ffff", borderRadius: 6 }}
              >
            <div className="px-4" style={{}}>
<br />
                  <h4 style={{ fontSize: '14px' }}>Delivery Address</h4>
                  <p style={{ color: '#2B2A29', fontSize: '12px' }}>{singleorder.shipping_address.first_name} {singleorder.shipping_address.last_name}</p>
                  <p style={{ fontSize: '12px' }}> {singleorder.shipping_address.line1}, {singleorder.shipping_address.line2},  {countryList.getName(singleorder.shipping_address.country)},{singleorder.shipping_address.state}, {singleorder.shipping_address.line4}, {singleorder.shipping_address.postcode} <br />
                  </p>
                  <p className="" style={{ fontSize: '12px' }}>
                    Mobile:{" "}
                    <span className="number2" style={{ color: '#2B2A29' }}>
                      {singleorder.shipping_address.phone_number}
                    </span>
                  </p>
                  <p className="" style={{ fontSize: '12px' }}>
                    Email ID:{" "}
                    <span className="number2" style={{ color: '#2B2A29' }} >
                      {singleorder.shipping_address.email}

                    </span>
                  </p>
                </div>
               
              
        
              </div> */}
               



                <div
                                   className="py-0"
                                   style={{
                                     position: "relative",
                                     top: "0px",
                                     background: "#ffff",
                                     borderRadius: 6,
                                     marginBottom: "10px",
                                   }}
                                 >
                                   <div
                                     className="firstrow px-4 d-flex justify-content-between"
                                     style={{ padding: "5px 0px", paddingLeft: "20px" }}
                                   >
                                     <h4
                                       style={{
                                         fontWeight: 700,
                                         // fontSize: "22px",
                                       }}
                                       className="titlesizes"
                                     >
                                       Confirm Delivery Address
                                     </h4>
                                   </div>
                                   <div
                                     className="firstrow px-4 pt-1 d-flex justify-content-between"
                                     style={{ flexDirection: "column" }}
                                   >
                                     <div className="customscroll">
                                     
                                       {addressdata.map((item, index) =>
                                         slectaddressid == item.id ? (
                                           <>
                                             {item.id != shippingid ? (
                                               <div
                                                 class="col-lg-12"
                                                 style={{
                                                   marginBottom: "9px",
                                                 }}
                                               >
                                                 <div class="card pt-1">
                                                   <div class="card-body p-0">
                                                     <div
                                                       class="form-check"
                                                       style={{
                                                         position: "relative",
                                                         display: "flex",
                                                         justifyContent: "flex-start",
                                                       }}
                                                     >
                                                      
                                                       <div
                                                         style={{
                                                           position: "absolute",
                                                           top: "9px",
                                                           left: "7px",
                                                           width: "13px",
                                                           height: "13px",
                                                           border: "1px solid",
                                                           borderRadius: "50%",
                                                           backgroundColor: `#${bgColor}`
                                                                                                   }}
                                                         onChange={() => {
                                                           setshippadd(item.id);
                                                         }}
                                                       ></div>
                                                       <h5
                                                         class="card-title "
                                                         style={{
                                                           textTransform: "capitalize",
                                                           position: "relative",
                                                           textAlign: "start",
                                                           paddingLeft: "9px",
                                                           margin: "0px",
                                                           fontSize: "13px",
                                                           position: "relative",
                                                           top: "4px",
                                                         }}
                                                       >
                                                         {item.first_name}&nbsp;
                                                         {item.last_name}{" "}
                                                         <span
                                                           style={{
                                                             fontSize: "10px",
                                                             color: "#8d9091",
                                                           }}
                                                         >
                                                           ({item.address_type})
                                                         </span>
                                                         {/* <span className="hello" style={{position:'absolute',top:'-1px',right:"0px"}}>
               
                                           </span> */}
                                                       </h5>
                                                     </div>
                                                     <p
                                                       className="small-text"
                                                       style={{
                                                         textAlign: "start",
                                                         paddingBottom: "6px",
                                                         fontSize: "13px",
                                                       }}
                                                     >
                                                       <span style={{ textWrap: "wrap" }}>
                                                         {item.line1}
                                                       </span>
                                                       &nbsp;
                                                       {item.line2}
                                                       &nbsp;
                                                       {item.country_printable_name}
                                                       &nbsp;
                                                       {item.state}
                                                       &nbsp;
                                                       {item.line4}-{item.postcode}
                                                     </p>
                                                     <div
                                                       class="form-check"
                                                       style={{
                                                         position: "relative",
                                                         display: "flex",
                                                         justifyContent: "flex-start",
                                                       }}
                                                     >
                                                      
               
                                                       <label
                                                         class="form-check-label mb-0"
                                                         for="flexRadioDefault1"
                                                         style={{ textAlign: "start" }}
                                                       >
                                                         <h5
                                                           className="number"
                                                           style={{
                                                             paddingBottom: "4px",
                                                             textAlign: "start",
                                                             fontSize: "13px",
                                                           }}
                                                         >
                                                           Mobile:{" "}
                                                           <span
                                                             className="number2"
                                                             style={{
                                                               textTransform: "none",
                                                               fontSize: "13px",
                                                             }}
                                                           >
                                                             {item.phone_number}
                                                           </span>
                                                         </h5>
                                                        
                                                       </label>
                                                     </div>
                                                   </div>
                                                 </div>
                                               </div>
                                             ) : (
                                               ""
                                             )}
                                           </>
                                         ) : (
                                           ""
                                         )
                                       )}
                                       {addressdata.map((item, index) =>
                                         slectaddressid != item.id ? (
                                           <>
                                             {item.id != shippingid ? (
                                               <div
                                                 class="col-lg-12"
                                                 style={{
                                                   marginBottom: "9px",
                                                 }}
                                               >
                                                 <div class="card pt-1">
                                                   <div class="card-body p-0">
                                                     <div
                                                       class="form-check"
                                                       style={{
                                                         position: "relative",
                                                         display: "flex",
                                                         justifyContent: "flex-start",
                                                       }}
                                                     >
                                                       <input
                                                         type="radio"
                                                         name="flexRadioDefault"
                                                         style={{
                                                           position: "absolute",
                                                           top: "9px",
                                                           left: "7px",
                                                         }}
                                                         // onChange={()=>{setshippadd(item.id)}}
                                                         onClick={(e) =>
                                                           selectaddress(item.id)
                                                         }
                                                       />
                                                       <h5
                                                         class="card-title "
                                                         style={{
                                                           textTransform: "capitalize",
                                                           position: "relative",
                                                           textAlign: "start",
                                                           paddingLeft: "9px",
                                                           margin: "0px",
                                                           fontSize: "13px",
                                                           position: "relative",
                                                           top: "4px",
                                                         }}
                                                       >
                                                         {item.first_name}&nbsp;
                                                         {item.last_name}{" "}
                                                         <span
                                                           style={{
                                                             fontSize: "10px",
                                                             color: "#8d9091",
                                                           }}
                                                         >
                                                           ({item.address_type})
                                                         </span>
                                                        
                                                       </h5>
                                                     </div>
                                                     <p
                                                       className="small-text"
                                                       style={{
                                                         textAlign: "start",
                                                         paddingBottom: "6px",
                                                         fontSize: "13px",
                                                       }}
                                                     >
                                                       <span style={{ textWrap: "balance" }}>
                                                         {item.line1}
                                                       </span>
                                                       &nbsp;
                                                       {item.line2}
                                                       &nbsp;
                                                       {item.country_printable_name}
                                                       &nbsp;
                                                       {item.state}
                                                       &nbsp;
                                                       {item.line4}-{item.postcode}
                                                     </p>
                                                     <div
                                                       class="form-check"
                                                       style={{
                                                         position: "relative",
                                                         display: "flex",
                                                         justifyContent: "flex-start",
                                                       }}
                                                     >
                                                     
               
                                                       <label
                                                         class="form-check-label mb-0"
                                                         for="flexRadioDefault1"
                                                         style={{ textAlign: "start" }}
                                                       >
                                                         <h5
                                                           className="number"
                                                           style={{
                                                             paddingBottom: "4px",
                                                             textAlign: "start",
                                                             fontSize: "13px",
                                                           }}
                                                         >
                                                           Mobile:{" "}
                                                           <span
                                                             className="number2"
                                                             style={{
                                                               textTransform: "none",
                                                               fontSize: "13px",
                                                             }}
                                                           >
                                                             {item.phone_number}
                                                           </span>
                                                         </h5>
                                                        
                                                       </label>
                                                     </div>
                                                   </div>
                                                 </div>
                                               </div>
                                             ) : (
                                               ""
                                             )}
                                           </>
                                         ) : (
                                           ""
                                         )
                                       )}
                                     </div>
                                   </div>
                                   <div className="firstrow px-4 pt-1 d-flex justify-content-between">
                                     <span
                                       style={{
                                         fontWeight: 600,
                                         fontSize: "12px",
                                         paddingLeft: "0px",
                                         alignSelf: "center",
                                       }}
                                     >
                                       {/* Select Address */}
                                     </span>
                                     <span
                                       style={{
                                         fontWeight: 500,
                                         color: "#0cb744",
                                         fontSize: "12px",
                                         // width:'50%'
                                         display: "flex",
                                         gap: "5px",
                                       }}
                                     >
                                       <button
                                         style={{
                                           border: "none",
                                           outline: "none",
                                           backgroundColor: "#fff",
                                           padding: "3px 3px",
                                           color: `#${bgColor}`,
                                         width: "fit-content",
                                           fontWeight: 600,
                                         }}
                                         data-bs-toggle="modal"
                                         data-bs-target="#exampleModaladdressone2"
                                         // onClick={()=>{handleClick()}}
                                       >
                                         +Add
                                       </button>
                                       <button
                                         style={{
                                           border: "none",
                                           outline: "none",
                                           backgroundColor: "#fff",
                                           padding: "3px 3px",
                                           color: `#${bgColor}`,
                                           width: "fit-content",
                                           fontWeight: 600,
                                         }}
                                         onClick={() => {
                                           editselectaddress();
                                         }}
                                       >
                                         <FaEdit
                                           style={{
                                             fontSize: "10px",
                                             position: "relative",
                                             top: "-1px",
                                             left: "2px",
                                           }}
                                         />{" "}
                                         Edit
                                       </button>
                                     </span>
                                   </div>
                                  </div>




              <div className="py-2 px-2"  style={{ background: "#ffff", borderRadius: 6 }} >                             
                            
              <h4
                      style={{
                        padding: "0px 14px",
                        fontWeight: 700,
                        // fontSize: "22px",
                      }}
                      className="titlesizes"

                    >
                      Payment Summary
                    </h4>

                <div
                  className="firstrow px-3 d-flex justify-content-between"
                  style={{ padding: "5px 0px" }}
                >
                  <span
                    className="family"
                    style={{ fontWeight: 600, fontSize: "12px" }}
                  >
                    Taxable Amount ({totalitemvalue} Item(s))
       
                  </span>
                  <span
                    className="family"
                    style={{
                      fontWeight: 500,
                      color: `#${bgColor}`,
                      fontSize: "12px",
                    }}
                  >
               
                    {/* ₹{voucherlist2[0] ? voucherlist2[0]?.voucher_type == "Gift Voucher - Inclusive" || voucherlist2[0]?.voucher_type == "Shopping Voucher - Inclusive" || voucherlist2[0]?.voucher_type == "Gift Voucher - Exclusive" || voucherlist2[0]?.voucher_type == "Shopping Voucher - Exclusive" ? (taxable_total).toFixed(0) : (taxable_total).toFixed(0) : totalitemvalue == 0 ? 0 : (totalmrp).toFixed(0)} */}
{Accountprice((taxable_total).toFixed(0))}

                  </span>
                </div>
                <div
                // {isshoppingvoucher[0]?.code ? singleorder.total_product_gst_value > 0 ? <div
                  className="firstrow px-3 d-flex justify-content-between"
                  style={{ padding: "5px 0px" }}
                >
                  <span
                    className="family"
                    style={{ fontWeight: 600, fontSize: "12px" }}
                  >
                    GST Amount
                  </span>
                  <span
                    className="family"
                    style={{
                      fontWeight: 500,
                      color: `#${bgColor}`,
                      fontSize: "12px",
                    }}
                  >
                    +
                    {/* ₹ */}
                    {Accountprice(singleorder.total_product_gst_value)}
                  </span>
                </div>
                {    voucherlist2[0] ? singleorder.total_product_gst_value > 0 ? <div
                // {isshoppingvoucher[0]?.code ? singleorder.total_product_gst_value > 0 ? <div
                  className="firstrow px-3 d-flex justify-content-between"
                  style={{ padding: "5px 0px" }}
                >
                  <span
                    className="family"
                    style={{ fontWeight: 600, fontSize: "12px" }}
                  >
                    GST Amount
                  </span>
                  <span
                    className="family"
                    style={{
                      fontWeight: 500,
                      color: "#0cb744",
                      fontSize: "12px",
                    }}
                  >
                    +
                    {/* ₹ */}
                    {Accountprice(singleorder.total_product_gst_value)}
                  </span>
                </div> : '' : ''}
                <div
                  className="firstrow px-3 d-flex justify-content-between"
                  style={{ padding: "5px 0px" }}
                >
                  <span
                    className="family"
                    style={{ fontWeight: 600, fontSize: "12px" }}
                  >
                    Shipping Charges
                  </span>
                  <span
                    className="family"
                    style={{
                      fontWeight: 500,
                      color: `#${bgColor}`,
                      fontSize: "12px",
                    }}
                  >
                  +
                  {/* ₹ */}
                  {Accountprice(shipping_price == 0 ? singleorder?.shiping_charge : shipping_price)}
                  </span>
                </div>
                {singleorder?.credit ? <div
                  className="firstrow px-3 d-flex justify-content-between"
                  style={{ padding: "5px 0px" }}
                >
                  <span
                    className="family"
                    style={{ fontWeight: 600, fontSize: "12px" }}
                  >
                    Credit
                  </span>
                  <span
                    className="family"
                    style={{
                      fontWeight: 500,
                      color: "#0cb744",
                      fontSize: "12px",
                    }}
                  >
                  
                  {/* ₹ */}
                  -{Accountprice(Math.abs(singleorder?.credit))}
                  </span>
                </div> : ''}
                {singleorder.voucher_list[0]?.offer ? <div
                  className="firstrow px-3 d-flex justify-content-between"
                  style={{ padding: "5px 0px", display: voucherlist2[0]?.offer ? 'block' : 'none' }}
                >
                  <span
                    className="family"
                    style={{ fontWeight: 600, fontSize: "12px" }}
                  >
                    Voucher Redemption
                  </span>
                  <span
                    style={{
                      color: "#0cb744",
                      fontWeight: 500,
                      fontSize: "12px",
                    }}
                  >
                    {" "}
                  </span>
                </div> : ''}
                {singleorder.voucher_list[0]?.offer ? singleorder.voucher_list.map((item, index) => (
                  <div className="firstrow px-2 mx-2 py-1 d-flex justify-content-between mt-1 align-items-center">
                    <div
                      className="firstcontianer d-flex align-items-start"
                      style={{ gap: 4 }}
                    >
                      <div className="containerimg">
                        <img src="/images/carticon.png" alt={404} />
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '4px', alignItems: 'baseline', minWidth: '192px' }}>
                        <p
                          className="m-0"
                          style={{ fontWeight: 400, fontSize: "12px" }}
                        >
                          {item.code} applied {item.voucher_type == 'Shopping Voucher - Exclusive' || item.voucher_type == 'Gift Voucher - Exclusive' ? 'excl. GST' : 'incl. GST'}
                        </p>
                      </div>
                    </div>
                    <div className="remove" style={{ flexDirection: 'column', paddingRight: '0px', padding: '0px' }}>
                      <span
                        style={{
                          color: "#0cb744",
                          fontWeight: 500,
                          fontSize: "12px",
                        }}
                      >
                        {/* - */}
                        {/* ₹ */}
                        -{Accountprice(item.offer)}
                      </span>
 
                    </div>
                  </div>
                )) : ''
                }



{data.length > 0 ?  voucherlist2?.[0]?.voucher_type != "Gift Voucher - Exclusive" && voucherlist2?.[0]?.voucher_type != "Gift Voucher - Inclusive"
 ? voucherlist2[0]?.offer ? (
                      <div
                        className="firstrow px-3 d-flex justify-content-between"
                        style={{ padding: "5px 0px" }}
                      >
                        <span
                          className="family"
                          style={{ fontWeight: 600, fontSize: "12px" }}
                        >
                        {voucherlist2[0]?.voucher_type == "Gift Voucher - Inclusive" || voucherlist2[0]?.voucher_type == "Gift Voucher - Exclusive" ? "Voucher Discount" : "Voucher Amount"}  
                        </span>
                        <span
                          className="family"
                          style={{
                            fontWeight: 500,
                            color: "#0cb744",
                            fontSize: "12px",
                          }}
                        >
                 {`-₹${offerSum}`}
                        </span>
                      </div>
                    ) : "" : "" : ""}
                {singleorder.voucher_list[0]?.offer ? <div
                  className="firstrow px-3 d-flex justify-content-between"
                  style={{ padding: "5px 0px" }}
                >
                  <span
                    className="family"
                    style={{ fontWeight: 600, fontSize: "12px" }}
                  >
                    Basic Amount
                  </span>
                  <span
                    className="family"
                    style={{
                      fontWeight: 500,
                      color: "#0cb744",
                      fontSize: "12px",
                    }}
                  >
                    {/* ₹ */}
                    {Accountprice(singleorder?.basic_amount_radeemable)}
                  </span>
                </div> : ''}
                
                {/* <div
                  className="firstrow px-3 justify-content-between"
                  style={{ padding: "5px 0px",display : tokenvalue.msg == "Voucher login" ? "none":"flex" }}
                >
                  <span
                    style={{
                      fontWeight: 600,
                      fontSize: "12px",
                      paddingLeft: "0px",
                    }}
                  >
                    Credit Utilize
                  </span>
                  <span
                    style={{
                      fontWeight: 500,
                      color: "#0cb744",
                      fontSize: "12px",
                    }}
                  >
                    ₹0{" "}
                    
                  </span>
                </div> */}



                <div className="firstrow px-3 pt-1 d-flex justify-content-between">
                  <span
                    style={{
                      fontWeight: 600,
                      fontSize: "12px",
                      paddingLeft: "0px",
                    }}
                  >
                        Amount Payable
                    <span
                      style={{
                        fontSize: "10px",
                        color: `#${bgColor}`,
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setshowtax(!showtax);
                      }}
                    >
                      <span
                        style={{
                          fontSize: 10,
                          color: `#${bgColor}`,
                          textAlign: 'end',
                          display: showtax == true ? "inline-block" : "none",
                        }}
                        id="span2"
                      >
                      {/* ₹ */}
                      {Accountprice(singleorder.total_product_gst_value ? singleorder.total_product_gst_value : 0)}
                      </span>
                    </span>
                  </span>
                  <span
                    style={{
                      fontWeight: 500,
                      color: `#${bgColor}`,
                      fontSize: "12px",
                    }}
                  >   
                    {/* ₹ */}
                    {Accountprice((singleorder.order_total_amount ? singleorder?.credit ? singleorder.order_total_amount -Math.abs(singleorder?.credit) : singleorder.order_total_amount : 0).toFixed(0))}
                  </span>
                </div>
                {/* <br />
                <hr /> */}

                {/* <div className="firstrow px-3 d-flex justify-content-between" style={{ padding: "5px 0px" }}>
                  <span className="family" style={{ fontWeight: 600, fontSize: "12px" }}>Payment Mode</span>
                  <span className="family" style={{ fontWeight: 500, color: '#8F9091', fontSize: '12px' }}>
                     {singleorder.payment_mode == "Razorpay" ? "Online Pay" : singleorder.payment_mode == "Wallet" ? "Wallet" : singleorder.payment_mode == "Custome" ? "Custom" : singleorder.payment_mode == "Credit" ? "Credit" : "COD"}</span>
                </div> */}
              </div>
              








              
              <div
                className="py-2 mt-lg-0 mt-md-3 mt-3"
                style={{ background: "#ffff", borderRadius: 6,display:paymentstatus == "Quotation_Shared" ? "block" : "none" }}
              >

               
                <div className="px-4">
                <button   style={{
                                  border: "none",
                                  outline: "none",
                                  backgroundColor: `#${bgColor}`,
                                  padding: "7px 0px",
                                  color: "white",
                                  width: "100%",
                                  fontWeight: 600,
                                }}
                                onClick={()=>{payment()}}
                              >
                               CONFIRM ORDER
                              </button>
                 
                </div>
        
              </div>

              
            </div>
          </div>
        </div>
      </section>
      {showtrack && (
        <div
          style={{
            position: 'fixed',
            top: 25,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
          }}
        >


          <div style={{ maxWidth: '32rem', minWidth: '32rem', margin: '0 auto', backgroundColor: 'white', padding: '1.5rem', border: '1px solid #e5e7eb', borderRadius: '0.5rem', minHeight: '10rem', maxHeight: '30rem', overflowY: 'auto' }}>
            <div style={{
              display: 'flex', justifyContent: 'space-between',
            }}>
              <span></span>
              <span
                onClick={() => setshowtrack(false)}
                style={{
                  fontSize: '1.5rem',
                  color: 'red',
                  cursor: 'pointer'

                }}
              >
                <IoIosCloseCircleOutline />
              </span>

            </div>

            <div style={{ paddingBottom: '1rem', borderBottom: '1px solid #e5e7eb', marginBottom: '1rem' }}>
              <h2 style={{ fontSize: '1.125rem', fontWeight: '600' }}>Delivery by OneUpShop</h2>
              <p style={{ fontSize: '0.875rem', color: '#6b7280' }}>Tracking ID:</p> <span> {awbNumber}</span>
               <p style={{ fontSize: '0.875rem', color: '#6b7280',display:'inline' }}>Estimated Delivery Date:</p>  {trackingData.tracking_data.etd ? <span> {trackingData.tracking_data.etd.split(' ')[0]}</span> : 'Will be Updated After Pickup'}  
              <p style={{ fontSize: '0.75rem', color: '#9ca3af' }}>This is your OneUpShop tracking number.</p>
            </div>

            {trackingData && trackingData.tracking_data.shipment_track_activities ? (
              trackingData.tracking_data.shipment_track_activities.map((activity, index) => (
                <div key={index} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '0.5rem' }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '0.5rem' }}>
                    <p style={{ width: '5rem', fontSize: '0.75rem', color: '#6b7280' }}>
                      {activity.date ? new Date(activity.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '00:00'}
                    </p>
                  </div>

                  <div>
                    {activity.activity && (
                      <>
                        <p style={{ fontSize: '0.875rem', color: '#374151' }}>{activity.activity}</p>
                        <p style={{ fontSize: '0.75rem', color: '#9ca3af' }}>{activity.location || 'Warehouse'}</p>
                      </>
                    )}
                    {!activity.activity && (
                      <>
                        <p style={{ fontSize: '0.875rem', color: '#374151' }}>Unknown Activity</p>
                        <p style={{ fontSize: '0.75rem', color: '#9ca3af' }}>{activity.location || 'Warehouse'}</p>
                      </>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div>
                <p>In Progress</p>
              </div>
            )}






          </div>
        </div>
      )}

      <div
                  class="modal fade"
                  id="exampleModaladdressone2"
                  tabindex="-1"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog" style={{ maxWidth: "770px" }}>
                    <div class="modal-content">
                      <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel">
                          Add Address
                        </h1>
                        <button
                          type="button"
                          ref={closeaddressbtn}
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div class="modal-body">
                        <Formik
                          initialValues={{
                            first_name: "",
                            last_name: "",
                            email: "",
                            mobile: "",
                            address1: "",
                            address2: "",
                            country: "",
                            countryurl: "",
                            state: "",
                            city: "",
                            pincode: "",
                            address_type: "HOME",
                          }}
                          validationSchema={checkoutvalidation}
                          onSubmit={(values, { setFieldError }) => {
                            createaddress(values, setFieldError);
                          }}
                        >
                          {({
                            values,
                            errors,
                            handleSubmit,
                            touched,
                            handleChange,
                            setFieldValue,
                            setFieldError,
                          }) => (
                            <Form autoComplete="off" onSubmit={handleSubmit}>
                              <div className="row check-out ">
                                <div className="form-group col-md-12 col-sm-12 col-xs-12 mb-0">
                                  <label className=" acounttitle field-label m-0">
                                    Address Type
                                    <span style={{ color: "red", fontSize: "13px" }}>
                                      {" "}
                                      *
                                    </span>
                                  </label>
                                  <div className="d-flex" style={{ gap: "10px" }}>
                                    <div>
                                      <label
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "2px",
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          name="address_type"
                                          value="HOME"
                                          onChange={handleChange}
                                          checked={values.address_type == "HOME"}
                                        />
                                        HOME
                                      </label>
                                    </div>
                                    <div>
                                      <label
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "2px",
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          name="address_type"
                                          value="OFFICE"
                                          onChange={handleChange}
                                          checked={values.address_type == "OFFICE"}
                                        />
                                        OFFICE
                                      </label>
                                    </div>
                                    <div>
                                      <label
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "2px",
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          name="address_type"
                                          value="OTHER"
                                          onChange={handleChange}
                                          checked={values.address_type == "OTHER"}
                                        />
                                        OTHER
                                      </label>
                                    </div>
                                  </div>
                                  <div className="error">
                                    {errors.address_type && touched.address_type ? (
                                      <p style={{ color: "red" }}>
                                        {errors.address_type}
                                      </p>
                                    ) : null}
                                  </div>
                                </div>
                                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                  <label className="acounttitle m-0">
                                    First Name{" "}
                                    <span style={{ color: "red", fontSize: "13px" }}>
                                      {" "}
                                      *
                                    </span>
                                  </label>
                                  {/* <input type="text" name="field-name" placeholder='First Name' /> */}
      
                                  <Field
                                    type="text"
                                    name="first_name"
                                    className="form-control"
                                    style={{ fontSize: "12px" }}
                                    placeholder="Enter Your First Name"
                                    value={values?.first_name}
                                  />
                                  <div className="error">
                                    {errors.first_name && touched.first_name ? (
                                      <p style={{ color: "red" }}>
                                        {errors.first_name}
                                      </p>
                                    ) : null}
                                  </div>
                                </div>
                                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                  <label className="acounttitle m-0">
                                    Last Name
                                    <span style={{ color: "red", fontSize: "13px" }}>
                                      {" "}
                                      *
                                    </span>
                                  </label>
                                  {/* <input type="text" name="field-name" placeholder='Last Name' /> */}
                                  <Field
                                    name="last_name"
                                    type="text"
                                    className="form-control"
                                    style={{ fontSize: "12px" }}
                                    placeholder="Enter Your Last Name"
                                    value={values?.last_name}
                                  />
                                  <div className="error">
                                    {errors.last_name && touched.last_name ? (
                                      <p style={{ color: "red" }}>
                                        {errors.last_name}
                                      </p>
                                    ) : null}
                                  </div>
                                </div>
                                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                  <label className="acounttitle field-label m-0">
                                    Phone
                                    <span style={{ color: "red", fontSize: "13px" }}>
                                      {" "}
                                      *
                                    </span>
                                  </label>
                                  {/* <input type="text" name="field-name" placeholder='Phone' /> */}
                                  <Field
                                    name="mobile"
                                    type="tel"
                                    style={{ fontSize: "12px" }}
                                    className="form-control"
                                    placeholder="Enter Your Mobile. No"
                                    value={values?.mobile}
                                    onChange={(e) => {
                                      setFieldValue(
                                        "mobile",
                                        e.target.value.replace(/\D/g, "")
                                      );
                                    }}
                                  />
                                  <div className="error">
                                    {errors.mobile && touched.mobile ? (
                                      <p style={{ color: "red" }}>{errors.mobile}</p>
                                    ) : null}
                                  </div>
                                </div>
                                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                  <label className="acounttitle field-label m-0">
                                    Email Address
                                    <span style={{ color: "red", fontSize: "13px" }}>
                                      {" "}
                                      *
                                    </span>
                                  </label>
                                  {/* <input type="text" name="field-name" placeholder='Email'/> */}
                                  <Field
                                    name="email"
                                    type="email"
                                    className="form-control"
                                    style={{ fontSize: "12px" }}
                                    placeholder="Enter Your Email Address"
                                    value={values?.email}
                                  />
                                  <div className="error">
                                    {errors.email && touched.email ? (
                                      <p style={{ color: "red" }}>{errors.email}</p>
                                    ) : null}
                                  </div>
                                </div>
      
                                <div className="form-group col-md-12 col-sm-12 col-xs-12">
                                  <label className="acounttitle field-label m-0">
                                    Address 1
                                    <span style={{ color: "red", fontSize: "13px" }}>
                                      {" "}
                                      *
                                    </span>
                                  </label>
                                  <Field
                                    name="address1"
                                    type="text"
                                    style={{ fontSize: "12px" }}
                                    className="form-control"
                                    placeholder="House number and street name"
                                    value={values.address1}
                                  />
                                  <div className="error">
                                    {errors.address1 && touched.address1 ? (
                                      <p style={{ color: "red" }}>
                                        {errors.address1}
                                      </p>
                                    ) : null}
                                  </div>
                                  {/* <input type="text" name="field-name" placeholder="House number and street name" /> */}
      
                                  {/* <input type="text" name="field-name" className="mt-2" placeholder="Apartment, suite, unit etc. (optional)" /> */}
                                </div>
                                <div className="form-group col-md-12 col-sm-12 col-xs-12">
                                  <label className="acounttitle field-label m-0">
                                    Address 2
                                    <span style={{ color: "red", fontSize: "13px" }}>
                                      {" "}
                                      *
                                    </span>
                                  </label>
                                  <Field
                                    name="address2"
                                    type="text"
                                    style={{ fontSize: "12px" }}
                                    className="form-control mt-2"
                                    placeholder="Apartment, suite, unit etc."
                                    value={values.address2}
                                  />
                                  <div className="error">
                                    {errors.address2 && touched.address2 ? (
                                      <p style={{ color: "red" }}>
                                        {errors.address2}
                                      </p>
                                    ) : null}
                                  </div>
                                  {/* <input type="text" name="field-name" placeholder="House number and street name" /> */}
      
                                  {/* <input type="text" name="field-name" className="mt-2" placeholder="Apartment, suite, unit etc. (optional)" /> */}
                                </div>
      
                                <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12">
                                  <label className=" acounttitle field-label m-0">
                                    Postal Code
                                    <span style={{ color: "red", fontSize: "13px" }}>
                                      {" "}
                                      *
                                    </span>
                                  </label>
                                  {/* <input type="text" name="field-name" placeholder="Pincode" /> */}
                                  <Field
                                    name="pincode"
                                    type="tel"
                                    style={{ fontSize: "12px" }}
                                    className="form-control"
                                    placeholder="Enter Your Pincode"
                                    value={values.pincode}
                                    minLength={6}
                                    maxLength={6}
                                    onChange={(e) => {
                                      setFieldValue(
                                        "pincode",
                                        e.target.value.replace(/[^0-9\ ]/gi, "")
                                      );
                                      fetchstateandcity(
                                        e.target.value.replace(/[^0-9\ ]/gi, ""),
                                        setFieldError,
                                        setFieldValue
                                      );
                                    }}
                                  />
                                  <div className="error">
                                    {errors.pincode && touched.pincode ? (
                                      <p style={{ color: "red" }}>{errors.pincode}</p>
                                    ) : null}
                                  </div>
                                </div>
      
                                {values.state !== "" &&
                                values.state !== null &&
                                cityna == "NA" ? (
                                  <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                                    <label className="acounttitle field-label m-0">
                                      City
                                      <span
                                        style={{ color: "red", fontSize: "13px" }}
                                      >
                                        {" "}
                                        *
                                      </span>
                                    </label>
                                    {/* <input type="text" name="field-name" placeholder="City" /> */}
                                    <Field
                                      name="city"
                                      type="text"
                                      style={{ fontSize: "12px" }}
                                      className="form-control"
                                      placeholder="Enter Your City"
                                      value={values.city}
                                    />
                                    {/* <Select onChange={(e)=>{setFieldValue("city",e.label)}} style={{fontSize:'11px'}} options={citylist == "" ? [] : updatedCities(citylist)}  /> */}
                                    <div className="error">
                                      {errors.city && touched.city ? (
                                        <p style={{ color: "red" }}>{errors.city}</p>
                                      ) : null}
                                    </div>
                                  </div>
                                ) : (
                                  <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                                    <label className="acounttitle field-label m-0">
                                      City
                                      <span
                                        style={{ color: "red", fontSize: "13px" }}
                                      >
                                        {" "}
                                        *
                                      </span>
                                    </label>
                                    {/* <input type="text" name="field-name" placeholder="City" /> */}
                                    <Field
                                      name="city"
                                      type="text"
                                      style={{ fontSize: "12px" }}
                                      className="form-control"
                                      placeholder="Enter Your City"
                                      readOnly
                                      value={values.city}
                                    />
                                    {/* <Select onChange={(e)=>{setFieldValue("city",e.label)}} style={{fontSize:'11px'}} options={citylist == "" ? [] : updatedCities(citylist)}  /> */}
                                    <div className="error">
                                      {errors.city && touched.city ? (
                                        <p style={{ color: "red" }}>{errors.city}</p>
                                      ) : null}
                                    </div>
                                  </div>
                                )}
      
                                {/* {console.log("reeffghgttffddddcc vvvvvv nnnnnnnnnn
                          
                          nn",errors,"llkkkkkkkkjjjhhhhgggfffffdsssss",values)} */}
                                <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                                  <label className="acounttitle field-label m-0">
                                    State
                                    <span style={{ color: "red", fontSize: "13px" }}>
                                      {" "}
                                      *
                                    </span>
                                  </label>
                                  {/* <input type="text" name="field-name" placeholder="State" /> */}
                                  <Field
                                    name="state"
                                    type="text"
                                    style={{ fontSize: "12px" }}
                                    className="form-control"
                                    placeholder="Enter Your State"
                                    readOnly
                                    value={values.state}
                                  />
                                  {/* <Select onChange={(e)=>{setcitylist(e.id);setFieldValue("state",e.label)}} style={{fontSize:'11px'}} options={statelist == "" ? [] : updatedStates(statelist)}  /> */}
                                  <div className="error">
                                    {errors.state && touched.state ? (
                                      <p style={{ color: "red" }}>{errors.state}</p>
                                    ) : null}
                                  </div>
                                </div>
      
                                <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                                  <label className="acounttitle field-label m-0">
                                    Country
                                    <span style={{ color: "red", fontSize: "13px" }}>
                                      {" "}
                                      *
                                    </span>
                                  </label>
                                  <Field
                                    name="country"
                                    type="text"
                                    style={{ fontSize: "12px" }}
                                    className="form-control"
                                    placeholder="Country"
                                    readOnly
                                    value={values.country}
                                  />
                                  <Field
                                    name="countryurl"
                                    type="hidden"
                                    style={{ fontSize: "12px" }}
                                    className="form-control"
                                    placeholder="Country"
                                    readOnly
                                    value={values.countryurl}
                                  />
                                  <div className="error">
                                    {errors.country && touched.country ? (
                                      <p style={{ color: "red" }}>{errors.country}</p>
                                    ) : null}
                                  </div>
                                </div>
      
                                <div className="form-group col-md-12 col-sm-12 col-xs-12 cht">
                                  <div className="payment-box">
                                    <div
                                      className="text-left"
                                      style={{
                                        display: "flex",
                                        justifyContent: "end",
                                        gap: "4px",
                                      }}
                                    >
                                      <button
                                        type="button"
                                        style={{
                                          fontSize: "12px",
                                          background: "#bdbfc0",
                                          color: "#000",
                                        }}
                                        className="btn-normal btn"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        ref={buttonRef}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        type="submit"
                                        style={{ fontSize: "12px" ,background :  `#${bgColor}`}}
                                        className="btn-normal btn"
                                      >
                                        Save
                                      </button>
                                    </div>
                                  </div>
                                </div>
      
                                <div className="form-group col-md-12 col-sm-12 col-xs-12 cht">
                                  <div
                                    class="alert alert-success"
                                    role="alert"
                                    style={{
                                      display:
                                        addressstatus == true ? "block" : "none",
                                    }}
                                  >
                                    Address Created Successfully
                                  </div>
                                </div>
                              </div>
                            </Form>
                          )}
                        </Formik>
                      </div>
                     
                    </div>
                  </div>
                </div>
                


                   <div
                            class="modal fade"
                            id="exampleModaladdressone3"
                            tabindex="-1"
                            aria-labelledby="exampleModalLabel"
                            aria-hidden="true"
                          >
                            <div class="modal-dialog" style={{ maxWidth: "785px" }}>
                              <div class="modal-content">
                                <div class="modal-header">
                                  <h1 class="modal-title fs-5" id="exampleModalLabel">
                                    Edit Address
                                  </h1>
                                  <button
                                    type="button"
                                    ref={editfromclose}
                                    class="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                  ></button>
                                </div>
                                <div
                                  class="modal-body"
                                  style={{ maxHeight: "90vh", overflowX: "hidden" }}
                                >
                                  <Formik
                                    initialValues={{
                                      first_name2: "",
                                      last_name2: "",
                                      email2: "",
                                      mobile2: "",
                                      address12: "",
                                      address22: "",
                                      country2: "",
                                      countryurl2: "",
                                      state2: "",
                                      city2: "",
                                      pincode2: "",
                                      address_type: "",
                                    }}
                                    validationSchema={checkoutvalidation2}
                                    onSubmit={(values, { setFieldError }) => {
                                      // console.log("this is eirt form")
                                      editddress(values, setFieldError);
                                    }}
                                  >
                                    {({
                                      values,
                                      errors,
                                      handleSubmit,
                                      touched,
                                      handleChange,
                                      setFieldValue,
                                      setFieldError,
                                    }) => (
                                      <Form
                                        autoComplete="off"
                                        onSubmit={(e) => {
                                          e.preventDefault();
                                          handleSubmit();
                                        }}
                                        //  onSubmit={handleSubmit}
                                      >
                                        <button
                                          type="button"
                                          // data-bs-toggle="modal"
                                          //             data-bs-target="#exampleModaladdressone3"
                                          ref={editformopen}
                                          onClick={() => {
                                            seteditformvalue(setFieldValue);
                                          }}
                                          style={{ position: "absolute", left: "5000px" }}
                                        ></button>
                                        <button
                                          type="button"
                                          data-bs-toggle="modal"
                                          data-bs-target="#exampleModaladdressone3"
                                          ref={editformopen2}
                                          style={{ position: "absolute", left: "5000px" }}
                                        ></button>
                                        {/* {console.log("this is error/ from error edit msg",errors,"va;ies",values)} */}
                                        <div className="row check-out ">
                                          <div className="form-group col-md-12 col-sm-12 col-xs-12 mb-0">
                                            <label
                                              className=" field-label mb-2"
                                              style={{ fontSize: "19px", fontWeight: "600" }}
                                            >
                                              Billing Address
                                              {/* <span style={{color:'red',fontSize:'13px'}}> *</span> */}
                                            </label>
                                          </div>
                
                                          <div className="form-group col-md-12 col-sm-12 col-xs-12 mb-0">
                                            <label className=" acounttitle field-label m-0">
                                              Address Type
                                              <span style={{ color: "red", fontSize: "13px" }}>
                                                {" "}
                                                *
                                              </span>
                                            </label>
                                           
                
                                            <div className="d-flex" style={{ gap: "10px" }}>
                                              <div>
                                                <label
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "2px",
                                                  }}
                                                >
                                                  <input
                                                    type="radio"
                                                    name="address_type"
                                                    value="HOME"
                                                    onChange={handleChange}
                                                    checked={values.address_type == "HOME"}
                                                  />
                                                  HOME
                                                </label>
                                              </div>
                                              <div>
                                                <label
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "2px",
                                                  }}
                                                >
                                                  <input
                                                    type="radio"
                                                    name="address_type"
                                                    value="OFFICE"
                                                    onChange={handleChange}
                                                    checked={values.address_type == "OFFICE"}
                                                  />
                                                  OFFICE
                                                </label>
                                              </div>
                                              <div>
                                                <label
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "2px",
                                                  }}
                                                >
                                                  <input
                                                    type="radio"
                                                    name="address_type"
                                                    value="OTHER"
                                                    onChange={handleChange}
                                                    checked={values.address_type == "OTHER"}
                                                  />
                                                  OTHER
                                                </label>
                                              </div>
                                            </div>
                                            <div className="error">
                                              {errors.address_type && touched.address_type ? (
                                                <p style={{ color: "red" }}>
                                                  {errors.address_type}
                                                </p>
                                              ) : null}
                                            </div>
                                          </div>
                                          <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                            <label className="acounttitle m-0">
                                              First Name{" "}
                                              <span style={{ color: "red", fontSize: "13px" }}>
                                                {" "}
                                                *
                                              </span>
                                            </label>
                                            {/* <input type="text" name="field-name" placeholder='First Name' /> */}
                
                                            <Field
                                              type="text"
                                              name="first_name2"
                                              className="form-control"
                                              style={{ fontSize: "12px" }}
                                              placeholder="Enter Your First Name"
                                              value={values?.first_name2}
                                            />
                                            <div className="error">
                                              {errors.first_name2 && touched.first_name2 ? (
                                                <p style={{ color: "red" }}>
                                                  {errors.first_name2}
                                                </p>
                                              ) : null}
                                            </div>
                                          </div>
                                          <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                            <label className="acounttitle m-0">
                                              Last Name
                                              <span style={{ color: "red", fontSize: "13px" }}>
                                                {" "}
                                                *
                                              </span>
                                            </label>
                                            {/* <input type="text" name="field-name" placeholder='Last Name' /> */}
                                            <Field
                                              name="last_name2"
                                              type="text"
                                              className="form-control"
                                              style={{ fontSize: "12px" }}
                                              placeholder="Enter Your Last Name"
                                              value={values?.last_name2}
                                            />
                                            <div className="error">
                                              {errors.last_name2 && touched.last_name2 ? (
                                                <p style={{ color: "red" }}>
                                                  {errors.last_name2}
                                                </p>
                                              ) : null}
                                            </div>
                                          </div>
                                          <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                            <label className="acounttitle field-label m-0">
                                              Phone
                                              <span style={{ color: "red", fontSize: "13px" }}>
                                                {" "}
                                                *
                                              </span>
                                            </label>
                                            {/* <input type="text" name="field-name" placeholder='Phone' /> */}
                                            <Field
                                              name="mobile2"
                                              type="tel"
                                              style={{ fontSize: "12px" }}
                                              className="form-control"
                                              placeholder="Enter Your Mobile. No"
                                              value={values?.mobile2}
                                              onChange={(e) => {
                                                setFieldValue(
                                                  "mobile2",
                                                  e.target.value.replace(/\D/g, "")
                                                );
                                              }}
                                            />
                                            <div className="error">
                                              {errors.mobile2 && touched.mobile2 ? (
                                                <p style={{ color: "red" }}>{errors.mobile2}</p>
                                              ) : null}
                                            </div>
                                          </div>
                                          <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                            <label className="acounttitle field-label m-0">
                                              Email Address
                                              <span style={{ color: "red", fontSize: "13px" }}>
                                                {" "}
                                                *
                                              </span>
                                            </label>
                                            {/* <input type="text" name="field-name" placeholder='Email'/> */}
                                            <Field
                                              name="email2"
                                              type="email"
                                              className="form-control"
                                              style={{ fontSize: "12px" }}
                                              placeholder="Enter Your Email Address"
                                              value={values?.email2}
                                            />
                                            <div className="error">
                                              {errors.email2 && touched.email2 ? (
                                                <p style={{ color: "red" }}>{errors.email2}</p>
                                              ) : null}
                                            </div>
                                          </div>
                
                                          <div className="form-group col-md-12 col-sm-12 col-xs-12">
                                            <label className="acounttitle field-label m-0">
                                              Address 1
                                              <span style={{ color: "red", fontSize: "13px" }}>
                                                {" "}
                                                *
                                              </span>
                                            </label>
                                            <Field
                                              name="address12"
                                              type="text"
                                              style={{ fontSize: "12px" }}
                                              className="form-control"
                                              placeholder="House number and street name"
                                              value={values.address12}
                                            />
                                            <div className="error">
                                              {errors.address12 && touched.address12 ? (
                                                <p style={{ color: "red" }}>
                                                  {errors.address12}
                                                </p>
                                              ) : null}
                                            </div>
                                            {/* <input type="text" name="field-name" placeholder="House number and street name" /> */}
                
                                            {/* <input type="text" name="field-name" className="mt-2" placeholder="Apartment, suite, unit etc. (optional)" /> */}
                                          </div>
                                          <div className="form-group col-md-12 col-sm-12 col-xs-12">
                                            <label className="acounttitle field-label m-0">
                                              Address 2
                                              <span style={{ color: "red", fontSize: "13px" }}>
                                                {" "}
                                                *
                                              </span>
                                            </label>
                                            <Field
                                              name="address22"
                                              type="text"
                                              style={{ fontSize: "12px" }}
                                              className="form-control mt-2"
                                              placeholder="Apartment, suite, unit etc."
                                              value={values.address22}
                                            />
                                            <div className="error">
                                              {errors.address22 && touched.address22 ? (
                                                <p style={{ color: "red" }}>
                                                  {errors.address22}
                                                </p>
                                              ) : null}
                                            </div>
                                          
                                          </div>
                
                                          <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12">
                                            <label className=" acounttitle field-label m-0">
                                              Postal Code
                                              <span style={{ color: "red", fontSize: "13px" }}>
                                                {" "}
                                                *
                                              </span>
                                            </label>
                                            {/* <input type="text" name="field-name" placeholder="Pincode" /> */}
                                            <Field
                                              name="pincode2"
                                              type="tel"
                                              style={{ fontSize: "12px" }}
                                              className="form-control"
                                              placeholder="Enter Your Pincode"
                                              value={values.pincode2}
                                              minLength={6}
                                              maxLength={6}
                                              onChange={(e) => {
                                                setFieldValue(
                                                  "pincode2",
                                                  e.target.value.replace(/[^0-9\ ]/gi, "")
                                                );
                                                fetchstateandcity2(
                                                  e.target.value.replace(/[^0-9\ ]/gi, ""),
                                                  setFieldError,
                                                  setFieldValue
                                                );
                                              }}
                                            />
                                            <div className="error">
                                              {errors.pincode2 && touched.pincode2 ? (
                                                <p style={{ color: "red" }}>
                                                  {errors.pincode2}
                                                </p>
                                              ) : null}
                                            </div>
                                          </div>
                
                                          {values.state2 !== "" &&
                                          values.state2 !== null &&
                                          cityna == "NA" ? (
                                            <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                                              <label className="acounttitle field-label m-0">
                                                City
                                                <span
                                                  style={{ color: "red", fontSize: "13px" }}
                                                >
                                                  {" "}
                                                  *
                                                </span>
                                              </label>
                                              {/* <input type="text" name="field-name" placeholder="City" /> */}
                                              <Field
                                                name="city2"
                                                type="text"
                                                style={{ fontSize: "12px" }}
                                                className="form-control"
                                                placeholder="Enter Your City"
                                                value={values.city2}
                                              />
                                              {/* <Select onChange={(e)=>{setFieldValue("city",e.label)}} style={{fontSize:'11px'}} options={citylist == "" ? [] : updatedCities(citylist)}  /> */}
                                              <div className="error">
                                                {errors.city2 && touched.city2 ? (
                                                  <p style={{ color: "red" }}>{errors.city2}</p>
                                                ) : null}
                                              </div>
                                            </div>
                                          ) : (
                                            <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                                              <label className="acounttitle field-label m-0">
                                                City
                                                <span
                                                  style={{ color: "red", fontSize: "13px" }}
                                                >
                                                  {" "}
                                                  *
                                                </span>
                                              </label>
                                              {/* <input type="text" name="field-name" placeholder="City" /> */}
                                              <Field
                                                name="city2"
                                                type="text"
                                                style={{ fontSize: "12px" }}
                                                className="form-control"
                                                placeholder="Enter Your City"
                                                readOnly
                                                value={values.city2}
                                              />
                                              {/* <Select onChange={(e)=>{setFieldValue("city",e.label)}} style={{fontSize:'11px'}} options={citylist == "" ? [] : updatedCities(citylist)}  /> */}
                                              <div className="error">
                                                {errors.city2 && touched.city2 ? (
                                                  <p style={{ color: "red" }}>{errors.city2}</p>
                                                ) : null}
                                              </div>
                                            </div>
                                          )}
                                          {/* {console.log("reeffghgttffddddcc vvvvvv nnnnnnnnnn
                                      
                                      nn",errors,"llkkkkkkkkjjjhhhhgggfffffdsssss",values)} */}
                                          <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                                            <label className="acounttitle field-label m-0">
                                              State
                                              <span style={{ color: "red", fontSize: "13px" }}>
                                                {" "}
                                                *
                                              </span>
                                            </label>
                                            {/* <input type="text" name="field-name" placeholder="State" /> */}
                                            <Field
                                              name="state2"
                                              type="text"
                                              style={{ fontSize: "12px" }}
                                              className="form-control"
                                              placeholder="Enter Your State"
                                              readOnly
                                              value={values.state2}
                                            />
                                            {/* <Select onChange={(e)=>{setcitylist(e.id);setFieldValue("state",e.label)}} style={{fontSize:'11px'}} options={statelist == "" ? [] : updatedStates(statelist)}  /> */}
                                            <div className="error">
                                              {errors.state2 && touched.state2 ? (
                                                <p style={{ color: "red" }}>{errors.state2}</p>
                                              ) : null}
                                            </div>
                                          </div>
                
                                          <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                                            <label className="acounttitle field-label m-0">
                                              Country
                                              <span style={{ color: "red", fontSize: "13px" }}>
                                                {" "}
                                                *
                                              </span>
                                            </label>
                                            <Field
                                              name="country2"
                                              type="text"
                                              style={{ fontSize: "12px" }}
                                              className="form-control"
                                              placeholder="Country"
                                              readOnly
                                              value={values.country2}
                                            />
                                            <Field
                                              name="countryurl2"
                                              type="hidden"
                                              style={{ fontSize: "12px" }}
                                              className="form-control"
                                              placeholder="Country"
                                              readOnly
                                              value={values.countryurl2}
                                            />
                                            <div className="error">
                                              {errors.country2 && touched.country2 ? (
                                                <p style={{ color: "red" }}>
                                                  {errors.country2}
                                                </p>
                                              ) : null}
                                            </div>
                                          </div>
                
                                          <div className="form-group col-md-12 col-sm-12 col-xs-12 cht">
                                            <div className="payment-box">
                                              <div
                                                className="text-left"
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "end",
                                                  gap: "4px",
                                                }}
                                              >
                                                <button
                                                  type="button"
                                                  style={{
                                                    fontSize: "12px",
                                                    background: "#bdbfc0",
                                                    color: "#000",
                                                  }}
                                                  className="btn-normal btn"
                                                  data-bs-dismiss="modal"
                                                  aria-label="Close"
                                                  ref={buttonRef}
                                                >
                                                  Cancel
                                                </button>
                                                <button
                                                  type="submit"
                                                  style={{ fontSize: "12px" ,background :  `#${bgColor}`}}
                                                  className="btn-normal btn"
                                                >
                                                  Update
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                
                                          <div className="form-group col-md-12 col-sm-12 col-xs-12 cht">
                                            <div
                                              class="alert alert-success"
                                              role="alert"
                                              style={{
                                                display:
                                                  addressstatus == true ? "block" : "none",
                                              }}
                                            >
                                              Address Created Successfully
                                            </div>
                                          </div>
                
                                          <div className="form-group col-md-12 col-sm-12 col-xs-12 cht mb-0 d-flex">
                                            {/* {console.log("this is sjippind response",shipaddress)} */}
                                            {/* <span style={{height:"18px",width: "18px",background: "#0cb744",display: "flex",justifyContent: "center",alignItems:"center"}}><FaCheck style={{fontSize:'10px',color:'white'}} /></span> */}
                                            <span
                                              style={{
                                                height: "18px",
                                                width: "18px",
                                                background:
                                                  shipaddress == false ? "#e9ecef" : `#${bgColor}`,
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                gap: "4px",
                                                borderRadius: "2px",
                                              }}
                                              onClick={() => {
                                                togglefun();
                                              }}
                                            >
                                              <FaCheck
                                                style={{
                                                  fontSize: "10px",
                                                  color: shipaddress == false ? "#000" : "#fff",
                                                }}
                                              />
                                            </span>
                                            {/* <input type="checkbox" name="" id="" onChange={()=>{setshipaddress(!shipaddress)}} style={{position:'relative',top:'2px'}} /> */}
                                            <span
                                              onClick={() => {
                                                togglefun();
                                              }}
                                            >
                                              {" "}
                                              SHIP TO A DIFFERENT ADDRESS?
                                            </span>
                                          </div>
                
                                          {shipaddress == false ? (
                                            ""
                                          ) : (
                                            <div className="form-group col-md-12 col-sm-12 col-xs-12 cht"></div>
                                          )}
                                        </div>
                                      </Form>
                                    )}
                                  </Formik>
                
                                  {shipaddress == false ? (
                                    ""
                                  ) : (
                                    <div
                                      className="form-group col-md-12 col-sm-12 col-xs-12 cht"
                                      style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "25px",
                                        marginBottom: "6px",
                                      }}
                                    >
                                      {shippingaddressopen == false ? (
                                        <>
                                          <div className="col-12">
                                            <h6
                                              style={{
                                                color: `#${textColor}`,
                                                position: "relative",
                                                top: "14px",
                                                cursor: "pointer",
                                              }}
                                              onClick={() => {
                                                setshippingaddressopen(!shippingaddressopen);
                                              }}
                                            >
                                              {" "}
                                              + Add Shipping Address
                                            </h6>
                                          </div>
                                          {addressdata.map((item, index) =>
                                            item.id == shippingid &&
                                            item.id != slectaddressid ? (
                                              <div
                                                class="col-lg-5"
                                                style={{
                                                  marginBottom: "9px",
                                                }}
                                              >
                                                <div class="card">
                                                  <div class="card-body">
                                                    <h5
                                                      class="card-title acounttitle"
                                                      style={{
                                                        textTransform: "capitalize",
                                                        position: "relative",
                                                      }}
                                                    >
                                                      {item.first_name}&nbsp;
                                                      {item.last_name}{" "}
                                                      <span
                                                        style={{
                                                          fontSize: "10px",
                                                          color: "#8d9091",
                                                        }}
                                                      >
                                                        ({item.address_type})
                                                      </span>
                                                      <span
                                                        className="hello"
                                                        style={{
                                                          position: "absolute",
                                                          top: "-1px",
                                                          right: "0px",
                                                        }}
                                                      >
                                                      
                                                      </span>
                                                    </h5>
                
                                                    <div
                                                      class="form-check"
                                                      style={{ position: "relative" }}
                                                    >
                                                      {shippingid == item.id ? (
                                                        <input
                                                          type="radio"
                                                          name="flexRadioDefault"
                                                          style={{
                                                            position: "absolute",
                                                            top: "9px",
                                                            left: "5px",
                                                          }}
                                                          onChange={() => {
                                                            setshippadd(item.id);
                                                          }}
                                                          checked
                                                        />
                                                      ) : (
                                                        <input
                                                          type="radio"
                                                          name="flexRadioDefault"
                                                          style={{
                                                            position: "absolute",
                                                            top: "9px",
                                                            left: "5px",
                                                          }}
                                                          onChange={() => {
                                                            setshippadd(item.id);
                                                          }}
                                                        />
                                                      )}
                
                                                      <label
                                                        class="form-check-label mb-0"
                                                        for="flexRadioDefault1"
                                                      >
                                                        <h5
                                                          className="number acounttitle"
                                                          style={{ paddingBottom: "4px" }}
                                                        >
                                                          Mobile:{" "}
                                                          <span
                                                            className="number2"
                                                            style={{
                                                              textTransform: "none",
                                                              fontSize: "13px",
                                                            }}
                                                          >
                                                            {item.phone_number}
                                                          </span>
                                                        </h5>
                                                        <h5 className="number acounttitle">
                                                          Email ID:{" "}
                                                          <span
                                                            className="number2"
                                                            style={{
                                                              textTransform: "none",
                                                              fontSize: "13px",
                                                            }}
                                                          >
                                                            {item.email}
                                                          </span>
                                                        </h5>
                                                      </label>
                                                    </div>
                                                    <p
                                                      className="small-text"
                                                      style={{ height: "40px" }}
                                                    >
                                                      <span style={{ textWrap: "nowrap" }}>
                                                        {item.line1}
                                                      </span>
                                                      &nbsp;
                                                      {item.line2}
                                                      &nbsp;
                                                      {item.country_printable_name}
                                                      &nbsp;
                                                      {item.state}
                                                      &nbsp;
                                                      {item.line4}-{item.postcode}
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : (
                                              ""
                                            )
                                          )}
                
                                          {addressdata.map((item, index) =>
                                            item.id != slectaddressid ? (
                                              <>
                                                {item.id != shippingid ? (
                                                  <div
                                                    class="col-lg-5"
                                                    style={{
                                                      marginBottom: "9px",
                                                    }}
                                                  >
                                                    <div class="card">
                                                      <div class="card-body">
                                                        <h5
                                                          class="card-title acounttitle"
                                                          style={{
                                                            textTransform: "capitalize",
                                                            position: "relative",
                                                          }}
                                                        >
                                                          {item.first_name}&nbsp;
                                                          {item.last_name}{" "}
                                                          <span
                                                            style={{
                                                              fontSize: "10px",
                                                              color: "#8d9091",
                                                            }}
                                                          >
                                                            ({item.address_type})
                                                          </span>
                                                          <span
                                                            className="hello"
                                                            style={{
                                                              position: "absolute",
                                                              top: "-1px",
                                                              right: "0px",
                                                            }}
                                                          >
                                                      
                                                          </span>
                                                        </h5>
                
                                                        <div
                                                          class="form-check"
                                                          style={{ position: "relative" }}
                                                        >
                                                          {item.id == shippingid ? (
                                                            <input
                                                              type="radio"
                                                              name="flexRadioDefault"
                                                              style={{
                                                                position: "absolute",
                                                                top: "9px",
                                                                left: "5px",
                                                              }}
                                                              onChange={() => {
                                                                setshippadd(item.id);
                                                              }}
                                                              checked
                                                            />
                                                          ) : (
                                                            <input
                                                              type="radio"
                                                              name="flexRadioDefault"
                                                              style={{
                                                                position: "absolute",
                                                                top: "9px",
                                                                left: "5px",
                                                              }}
                                                              onChange={() => {
                                                                setshippadd(item.id);
                                                              }}
                                                            />
                                                          )}
                
                                                          <label
                                                            class="form-check-label mb-0"
                                                            for="flexRadioDefault1"
                                                          >
                                                            <h5
                                                              className="number acounttitle"
                                                              style={{ paddingBottom: "4px" }}
                                                            >
                                                              Mobile:{" "}
                                                              <span
                                                                className="number2"
                                                                style={{
                                                                  textTransform: "none",
                                                                  fontSize: "13px",
                                                                }}
                                                              >
                                                                {item.phone_number}
                                                              </span>
                                                            </h5>
                                                            <h5 className="number acounttitle">
                                                              Email ID:{" "}
                                                              <span
                                                                className="number2"
                                                                style={{
                                                                  textTransform: "none",
                                                                  fontSize: "13px",
                                                                }}
                                                              >
                                                                {item.email}
                                                              </span>
                                                            </h5>
                                                          </label>
                                                        </div>
                                                        <p
                                                          className="small-text"
                                                          style={{ height: "40px" }}
                                                        >
                                                          <span style={{ textWrap: "nowrap" }}>
                                                            {item.line1}
                                                          </span>
                                                          &nbsp;
                                                          {item.line2}
                                                          &nbsp;
                                                          {item.country_printable_name}
                                                          &nbsp;
                                                          {item.state}
                                                          &nbsp;
                                                          {item.line4}-{item.postcode}
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </>
                                            ) : (
                                              ""
                                            )
                                          )}
                                        </>
                                      ) : (
                                        <Formik
                                          initialValues={{
                                            first_name: "",
                                            last_name: "",
                                            email: "",
                                            mobile: "",
                                            address1: "",
                                            address2: "",
                                            country: "",
                                            countryurl: "",
                                            state: "",
                                            city: "",
                                            pincode: "",
                                            address_type: "HOME",
                                          }}
                                          validationSchema={checkoutvalidation}
                                          onSubmit={(values, { setFieldError }) => {
                                            createaddress(values, setFieldError, "shippingadd");
                                          }}
                                        >
                                          {({
                                            values,
                                            errors,
                                            handleSubmit,
                                            touched,
                                            setFieldValue,
                                            handleChange,
                                            setFieldError,
                                          }) => (
                                            <Form autoComplete="off" onSubmit={handleSubmit}>
                                              <div className="row check-out ">
                                                <div className="form-group col-md-12 col-sm-12 col-xs-12 mb-0">
                                                  <label className=" acounttitle field-label m-0">
                                                    Address Type
                                                    <span
                                                      style={{ color: "red", fontSize: "13px" }}
                                                    >
                                                      {" "}
                                                      *
                                                    </span>
                                                  </label>
                                              
                
                                                  <div
                                                    className="d-flex"
                                                    style={{ gap: "10px" }}
                                                  >
                                                    <div>
                                                      <label
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                          gap: "2px",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          name="address_type"
                                                          value="HOME"
                                                          onChange={handleChange}
                                                          checked={
                                                            values.address_type == "HOME"
                                                          }
                                                        />
                                                        HOME
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                          gap: "2px",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          name="address_type"
                                                          value="OFFICE"
                                                          onChange={handleChange}
                                                          checked={
                                                            values.address_type == "OFFICE"
                                                          }
                                                        />
                                                        OFFICE
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                          gap: "2px",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          name="address_type"
                                                          value="OTHER"
                                                          onChange={handleChange}
                                                          checked={
                                                            values.address_type == "OTHER"
                                                          }
                                                        />
                                                        OTHER
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <div className="error">
                                                    {errors.address_type &&
                                                    touched.address_type ? (
                                                      <p style={{ color: "red" }}>
                                                        {errors.address_type}
                                                      </p>
                                                    ) : null}
                                                  </div>
                                                </div>
                
                                                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                                  <label className="acounttitle m-0">
                                                    First Name{" "}
                                                    <span
                                                      style={{ color: "red", fontSize: "13px" }}
                                                    >
                                                      {" "}
                                                      *
                                                    </span>
                                                  </label>
                                                  {/* <input type="text" name="field-name" placeholder='First Name' /> */}
                
                                                  <Field
                                                    type="text"
                                                    name="first_name"
                                                    className="form-control"
                                                    style={{ fontSize: "12px" }}
                                                    placeholder="Enter Your First Name"
                                                    value={values?.first_name}
                                                  />
                                                  <div className="error">
                                                    {errors.first_name && touched.first_name ? (
                                                      <p style={{ color: "red" }}>
                                                        {errors.first_name}
                                                      </p>
                                                    ) : null}
                                                  </div>
                                                </div>
                                                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                                  <label className="acounttitle m-0">
                                                    Last Name
                                                    <span
                                                      style={{ color: "red", fontSize: "13px" }}
                                                    >
                                                      {" "}
                                                      *
                                                    </span>
                                                  </label>
                                                  {/* <input type="text" name="field-name" placeholder='Last Name' /> */}
                                                  <Field
                                                    name="last_name"
                                                    type="text"
                                                    className="form-control"
                                                    style={{ fontSize: "12px" }}
                                                    placeholder="Enter Your Last Name"
                                                    value={values?.last_name}
                                                  />
                                                  <div className="error">
                                                    {errors.last_name && touched.last_name ? (
                                                      <p style={{ color: "red" }}>
                                                        {errors.last_name}
                                                      </p>
                                                    ) : null}
                                                  </div>
                                                </div>
                                                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                                  <label className="acounttitle field-label m-0">
                                                    Phone
                                                    <span
                                                      style={{ color: "red", fontSize: "13px" }}
                                                    >
                                                      {" "}
                                                      *
                                                    </span>
                                                  </label>
                                                  {/* <input type="text" name="field-name" placeholder='Phone' /> */}
                                                  <Field
                                                    name="mobile"
                                                    type="tel"
                                                    style={{ fontSize: "12px" }}
                                                    className="form-control"
                                                    placeholder="Enter Your Mobile. No"
                                                    value={values?.mobile}
                                                    onChange={(e) => {
                                                      setFieldValue(
                                                        "mobile",
                                                        e.target.value.replace(/\D/g, "")
                                                      );
                                                    }}
                                                  />
                                                  <div className="error">
                                                    {errors.mobile && touched.mobile ? (
                                                      <p style={{ color: "red" }}>
                                                        {errors.mobile}
                                                      </p>
                                                    ) : null}
                                                  </div>
                                                </div>
                                                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                                  <label className="acounttitle field-label m-0">
                                                    Email Address
                                                    <span
                                                      style={{ color: "red", fontSize: "13px" }}
                                                    >
                                                      {" "}
                                                      *
                                                    </span>
                                                  </label>
                                                  {/* <input type="text" name="field-name" placeholder='Email'/> */}
                                                  <Field
                                                    name="email"
                                                    type="email"
                                                    className="form-control"
                                                    style={{ fontSize: "12px" }}
                                                    placeholder="Enter Your Email Address"
                                                    value={values?.email}
                                                  />
                                                  <div className="error">
                                                    {errors.email && touched.email ? (
                                                      <p style={{ color: "red" }}>
                                                        {errors.email}
                                                      </p>
                                                    ) : null}
                                                  </div>
                                                </div>
                
                                                <div className="form-group col-md-12 col-sm-12 col-xs-12">
                                                  <label className="acounttitle field-label m-0">
                                                    Address 1
                                                    <span
                                                      style={{ color: "red", fontSize: "13px" }}
                                                    >
                                                      {" "}
                                                      *
                                                    </span>
                                                  </label>
                                                  <Field
                                                    name="address1"
                                                    type="text"
                                                    style={{ fontSize: "12px" }}
                                                    className="form-control"
                                                    placeholder="House number and street name"
                                                    value={values.address1}
                                                  />
                                                  <div className="error">
                                                    {errors.address1 && touched.address1 ? (
                                                      <p style={{ color: "red" }}>
                                                        {errors.address1}
                                                      </p>
                                                    ) : null}
                                                  </div>
                                                  {/* <input type="text" name="field-name" placeholder="House number and street name" /> */}
                
                                                  {/* <input type="text" name="field-name" className="mt-2" placeholder="Apartment, suite, unit etc. (optional)" /> */}
                                                </div>
                                                <div className="form-group col-md-12 col-sm-12 col-xs-12">
                                                  <label className="acounttitle field-label m-0">
                                                    Address 2
                                                    <span
                                                      style={{ color: "red", fontSize: "13px" }}
                                                    >
                                                      {" "}
                                                      *
                                                    </span>
                                                  </label>
                                                  <Field
                                                    name="address2"
                                                    type="text"
                                                    style={{ fontSize: "12px" }}
                                                    className="form-control mt-2"
                                                    placeholder="Apartment, suite, unit etc."
                                                    value={values.address2}
                                                  />
                                                  <div className="error">
                                                    {errors.address2 && touched.address2 ? (
                                                      <p style={{ color: "red" }}>
                                                        {errors.address2}
                                                      </p>
                                                    ) : null}
                                                  </div>
                                                 
                                                </div>
                
                                                <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12">
                                                  <label className=" acounttitle field-label m-0">
                                                    Postal Code
                                                    <span
                                                      style={{ color: "red", fontSize: "13px" }}
                                                    >
                                                      {" "}
                                                      *
                                                    </span>
                                                  </label>
                                                  {/* <input type="text" name="field-name" placeholder="Pincode" /> */}
                                                  <Field
                                                    name="pincode"
                                                    type="tel"
                                                    style={{ fontSize: "12px" }}
                                                    className="form-control"
                                                    placeholder="Enter Your Pincode"
                                                    value={values.pincode}
                                                    minLength={6}
                                                    maxLength={6}
                                                    onChange={(e) => {
                                                      setFieldValue(
                                                        "pincode",
                                                        e.target.value.replace(/[^0-9\ ]/gi, "")
                                                      );
                                                      fetchstateandcity(
                                                        e.target.value.replace(
                                                          /[^0-9\ ]/gi,
                                                          ""
                                                        ),
                                                        setFieldError,
                                                        setFieldValue
                                                      );
                                                    }}
                                                  />
                                                  <div className="error">
                                                    {errors.pincode && touched.pincode ? (
                                                      <p style={{ color: "red" }}>
                                                        {errors.pincode}
                                                      </p>
                                                    ) : null}
                                                  </div>
                                                </div>
                                                {values.state !== "" &&
                                                values.state !== null &&
                                                cityna == "NA" ? (
                                                  <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                                                    <label className="acounttitle field-label m-0">
                                                      City
                                                      <span
                                                        style={{
                                                          color: "red",
                                                          fontSize: "13px",
                                                        }}
                                                      >
                                                        {" "}
                                                        *
                                                      </span>
                                                    </label>
                                                    {/* <input type="text" name="field-name" placeholder="City" /> */}
                                                    <Field
                                                      name="city"
                                                      type="text"
                                                      style={{ fontSize: "12px" }}
                                                      className="form-control"
                                                      placeholder="Enter Your City"
                                                      value={values.city}
                                                    />
                                                    {/* <Select onChange={(e)=>{setFieldValue("city",e.label)}} style={{fontSize:'11px'}} options={citylist == "" ? [] : updatedCities(citylist)}  /> */}
                                                    <div className="error">
                                                      {errors.city && touched.city ? (
                                                        <p style={{ color: "red" }}>
                                                          {errors.city}
                                                        </p>
                                                      ) : null}
                                                    </div>
                                                  </div>
                                                ) : (
                                                  <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                                                    <label className="acounttitle field-label m-0">
                                                      City
                                                      <span
                                                        style={{
                                                          color: "red",
                                                          fontSize: "13px",
                                                        }}
                                                      >
                                                        {" "}
                                                        *
                                                      </span>
                                                    </label>
                                                    {/* <input type="text" name="field-name" placeholder="City" /> */}
                                                    <Field
                                                      name="city"
                                                      type="text"
                                                      style={{ fontSize: "12px" }}
                                                      className="form-control"
                                                      placeholder="Enter Your City"
                                                      readOnly
                                                      value={values.city}
                                                    />
                                                    {/* <Select onChange={(e)=>{setFieldValue("city",e.label)}} style={{fontSize:'11px'}} options={citylist == "" ? [] : updatedCities(citylist)}  /> */}
                                                    <div className="error">
                                                      {errors.city && touched.city ? (
                                                        <p style={{ color: "red" }}>
                                                          {errors.city}
                                                        </p>
                                                      ) : null}
                                                    </div>
                                                  </div>
                                                )}
                
                                                {/* {console.log("reeffghgttffddddcc vvvvvv nnnnnnnnnn
                                                  
                                                  nn",errors,"llkkkkkkkkjjjhhhhgggfffffdsssss",values)} */}
                                                <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                                                  <label className="acounttitle field-label m-0">
                                                    State
                                                    <span
                                                      style={{ color: "red", fontSize: "13px" }}
                                                    >
                                                      {" "}
                                                      *
                                                    </span>
                                                  </label>
                                                  {/* <input type="text" name="field-name" placeholder="State" /> */}
                                                  <Field
                                                    name="state"
                                                    type="text"
                                                    style={{ fontSize: "12px" }}
                                                    className="form-control"
                                                    placeholder="Enter Your State"
                                                    readOnly
                                                    value={values.state}
                                                  />
                                                  {/* <Select onChange={(e)=>{setcitylist(e.id);setFieldValue("state",e.label)}} style={{fontSize:'11px'}} options={statelist == "" ? [] : updatedStates(statelist)}  /> */}
                                                  <div className="error">
                                                    {errors.state && touched.state ? (
                                                      <p style={{ color: "red" }}>
                                                        {errors.state}
                                                      </p>
                                                    ) : null}
                                                  </div>
                                                </div>
                
                                                <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                                                  <label className="acounttitle field-label m-0">
                                                    Country
                                                    <span
                                                      style={{ color: "red", fontSize: "13px" }}
                                                    >
                                                      {" "}
                                                      *
                                                    </span>
                                                  </label>
                                                  <Field
                                                    name="country"
                                                    type="text"
                                                    style={{ fontSize: "12px" }}
                                                    className="form-control"
                                                    placeholder="Country"
                                                    readOnly
                                                    value={values.country}
                                                  />
                                                  <Field
                                                    name="countryurl"
                                                    type="hidden"
                                                    style={{ fontSize: "12px" }}
                                                    className="form-control"
                                                    placeholder="Country"
                                                    readOnly
                                                    value={values.countryurl}
                                                  />
                                                  <div className="error">
                                                    {errors.country && touched.country ? (
                                                      <p style={{ color: "red" }}>
                                                        {errors.country}
                                                      </p>
                                                    ) : null}
                                                  </div>
                                                </div>
                
                                                <div className="form-group col-md-12 col-sm-12 col-xs-12 cht">
                                                  <div className="payment-box">
                                                    <div
                                                      className="text-left"
                                                      style={{
                                                        display: "flex",
                                                        justifyContent: "end",
                                                        gap: "4px",
                                                      }}
                                                    >
                                                      <button
                                                        type="button"
                                                        style={{
                                                          fontSize: "12px",
                                                          background: "#bdbfc0",
                                                          color: "#000",
                                                        }}
                                                        className="btn-normal btn"
                                                        data-bs-dismiss="modal"
                                                        aria-label="Close"
                                                        // ref={buttonRef}
                                                        onClick={() => {
                                                          setshippingaddressopen(
                                                            !shippingaddressopen
                                                          );
                                                        }}
                                                      >
                                                        Back
                                                      </button>
                                                      <button
                                                        type="submit"
                                                        style={{ fontSize: "12px",backgroundColor: `#${bgColor}` }}
                                                        className="btn-normal btn"
                                                      >
                                                        Save
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                
                                                <div className="form-group col-md-12 col-sm-12 col-xs-12 cht">
                                                  <div
                                                    class="alert alert-success"
                                                    role="alert"
                                                    style={{
                                                      display:
                                                        addressstatus == true
                                                          ? "block"
                                                          : "none",
                                                    }}
                                                  >
                                                    Address Created Successfully
                                                  </div>
                                                </div>
                                              </div>
                                            </Form>
                                          )}
                                        </Formik>
                                      )}
                                    </div>
                                  )}
                              
                
                
                
                
                
                                </div>
                              </div>
                            </div>
                          </div>

      {/*section end*/}

      {/* <Footer /> */}
    </>
  );
};
export default OrderRequest;
